const o = `
  --hsds-token-color-red-100: #fff0e8ff;
  --hsds-token-color-red-100-rgb: 255,240,232;
  --hsds-token-color-red-200: #fedfd5ff;
  --hsds-token-color-red-200-rgb: 254,223,213;
  --hsds-token-color-red-300: #ffbcadff;
  --hsds-token-color-red-300-rgb: 255,188,173;
  --hsds-token-color-red-400: #fa7a64ff;
  --hsds-token-color-red-400-rgb: 250,122,100;
  --hsds-token-color-red-500: #e54a32ff;
  --hsds-token-color-red-500-rgb: 229,74,50;
  --hsds-token-color-red-600: #b83525ff;
  --hsds-token-color-red-600-rgb: 184,53,37;
  --hsds-token-color-red-700: #822824ff;
  --hsds-token-color-red-700-rgb: 130,40,36;
  --hsds-token-color-red-800: #592728ff;
  --hsds-token-color-red-800-rgb: 89,39,40;
  --hsds-token-color-red-900: #402629ff;
  --hsds-token-color-red-900-rgb: 64,38,41;
  --hsds-token-color-red-1000: #2b2123ff;
  --hsds-token-color-red-1000-rgb: 43,33,35;
  --hsds-token-color-red-default: var(--hsds-token-color-red-500);
  --hsds-token-color-red-accent: #ff4747ff;
  --hsds-token-color-red-accent-rgb: 255,71,71;
  --hsds-token-color-orange-100: #fff2e8ff;
  --hsds-token-color-orange-100-rgb: 255,242,232;
  --hsds-token-color-orange-200: #ffe4d1ff;
  --hsds-token-color-orange-200-rgb: 255,228,209;
  --hsds-token-color-orange-300: #fac096ff;
  --hsds-token-color-orange-300-rgb: 250,192,150;
  --hsds-token-color-orange-400: #f5964eff;
  --hsds-token-color-orange-400-rgb: 245,150,78;
  --hsds-token-color-orange-500: #d67022ff;
  --hsds-token-color-orange-500-rgb: 214,112,34;
  --hsds-token-color-orange-600: #a35214ff;
  --hsds-token-color-orange-600-rgb: 163,82,20;
  --hsds-token-color-orange-700: #7a4518ff;
  --hsds-token-color-orange-700-rgb: 122,69,24;
  --hsds-token-color-orange-800: #573b23ff;
  --hsds-token-color-orange-800-rgb: 87,59,35;
  --hsds-token-color-orange-900: #3d2f22ff;
  --hsds-token-color-orange-900-rgb: 61,47,34;
  --hsds-token-color-orange-1000: #2b241dff;
  --hsds-token-color-orange-1000-rgb: 43,36,29;
  --hsds-token-color-orange-default: var(--hsds-token-color-orange-500);
  --hsds-token-color-orange-accent: #ff8b33ff;
  --hsds-token-color-orange-accent-rgb: 255,139,51;
  --hsds-token-color-yellow-100: #fff6e5ff;
  --hsds-token-color-yellow-100-rgb: 255,246,229;
  --hsds-token-color-yellow-200: #ffeeccff;
  --hsds-token-color-yellow-200-rgb: 255,238,204;
  --hsds-token-color-yellow-300: #ffdd99ff;
  --hsds-token-color-yellow-300-rgb: 255,221,153;
  --hsds-token-color-yellow-400: #fabf5aff;
  --hsds-token-color-yellow-400-rgb: 250,191,90;
  --hsds-token-color-yellow-500: #e09c24ff;
  --hsds-token-color-yellow-500-rgb: 224,156,36;
  --hsds-token-color-yellow-600: #ac771bff;
  --hsds-token-color-yellow-600-rgb: 172,119,27;
  --hsds-token-color-yellow-700: #7a581dff;
  --hsds-token-color-yellow-700-rgb: 122,88,29;
  --hsds-token-color-yellow-800: #574323ff;
  --hsds-token-color-yellow-800-rgb: 87,67,35;
  --hsds-token-color-yellow-900: #403521ff;
  --hsds-token-color-yellow-900-rgb: 64,53,33;
  --hsds-token-color-yellow-950: var(--hsds-token-color-yellow-900);
  --hsds-token-color-yellow-950-rgb: var(--hsds-token-color-yellow-900-rgb);
  --hsds-token-color-yellow-1000: #2b261dff;
  --hsds-token-color-yellow-1000-rgb: 43,38,29;
  --hsds-token-color-yellow-default: var(--hsds-token-color-yellow-500);
  --hsds-token-color-yellow-accent: #ffb83dff;
  --hsds-token-color-yellow-accent-rgb: 255,184,61;
  --hsds-token-color-green-100: #f2fff0ff;
  --hsds-token-color-green-100-rgb: 242,255,240;
  --hsds-token-color-green-200: #e0fcdeff;
  --hsds-token-color-green-200-rgb: 224,252,222;
  --hsds-token-color-green-300: #b9edbdff;
  --hsds-token-color-green-300-rgb: 185,237,189;
  --hsds-token-color-green-400: #83db9cff;
  --hsds-token-color-green-400-rgb: 131,219,156;
  --hsds-token-color-green-500: #47c47dff;
  --hsds-token-color-green-500-rgb: 71,196,125;
  --hsds-token-color-green-600: #2d8556ff;
  --hsds-token-color-green-600-rgb: 45,133,86;
  --hsds-token-color-green-700: #28704cff;
  --hsds-token-color-green-700-rgb: 40,112,76;
  --hsds-token-color-green-750: var(--hsds-token-color-green-800);
  --hsds-token-color-green-750-rgb: var(--hsds-token-color-green-800-rgb);
  --hsds-token-color-green-800: #2e5940ff;
  --hsds-token-color-green-800-rgb: 46,89,64;
  --hsds-token-color-green-900: #283b2dff;
  --hsds-token-color-green-900-rgb: 40,59,45;
  --hsds-token-color-green-1000: #222923ff;
  --hsds-token-color-green-1000-rgb: 34,41,35;
  --hsds-token-color-green-default: var(--hsds-token-color-green-500);
  --hsds-token-color-green-accent: #56f09eff;
  --hsds-token-color-green-accent-rgb: 86,240,158;
  --hsds-token-color-slate-100: #f2f9fcff;
  --hsds-token-color-slate-100-rgb: 242,249,252;
  --hsds-token-color-slate-200: #e1eef5ff;
  --hsds-token-color-slate-200-rgb: 225,238,245;
  --hsds-token-color-slate-300: #ccdee8ff;
  --hsds-token-color-slate-300-rgb: 204,222,232;
  --hsds-token-color-slate-400: #a9c4d4ff;
  --hsds-token-color-slate-400-rgb: 169,196,212;
  --hsds-token-color-slate-500: #82a7baff;
  --hsds-token-color-slate-500-rgb: 130,167,186;
  --hsds-token-color-slate-600: #658b9eff;
  --hsds-token-color-slate-600-rgb: 101,139,158;
  --hsds-token-color-slate-700: #486878ff;
  --hsds-token-color-slate-700-rgb: 72,104,120;
  --hsds-token-color-slate-800: #344852ff;
  --hsds-token-color-slate-800-rgb: 52,72,82;
  --hsds-token-color-slate-900: #283338ff;
  --hsds-token-color-slate-900-rgb: 40,51,56;
  --hsds-token-color-slate-1000: #1f2426ff;
  --hsds-token-color-slate-1000-rgb: 31,36,38;
  --hsds-token-color-slate-default: var(--hsds-token-color-slate-500);
  --hsds-token-color-slate-accent: #47c2ffff;
  --hsds-token-color-slate-accent-rgb: 71,194,255;
  --hsds-token-color-cobalt-100: #ebf5ffff;
  --hsds-token-color-cobalt-100-rgb: 235,245,255;
  --hsds-token-color-cobalt-200: #d1e8ffff;
  --hsds-token-color-cobalt-200-rgb: 209,232,255;
  --hsds-token-color-cobalt-300: #9ecbffff;
  --hsds-token-color-cobalt-300-rgb: 158,203,255;
  --hsds-token-color-cobalt-400: #66a3ffff;
  --hsds-token-color-cobalt-400-rgb: 102,163,255;
  --hsds-token-color-cobalt-500: #4176faff;
  --hsds-token-color-cobalt-500-rgb: 65,118,250;
  --hsds-token-color-cobalt-600: #304ddbff;
  --hsds-token-color-cobalt-600-rgb: 48,77,219;
  --hsds-token-color-cobalt-700: #263aadff;
  --hsds-token-color-cobalt-700-rgb: 38,58,173;
  --hsds-token-color-cobalt-800: #1c2674ff;
  --hsds-token-color-cobalt-800-rgb: 28,38,116;
  --hsds-token-color-cobalt-900: #171952ff;
  --hsds-token-color-cobalt-900-rgb: 23,25,82;
  --hsds-token-color-cobalt-1000: #0e0e33ff;
  --hsds-token-color-cobalt-1000-rgb: 14,14,51;
  --hsds-token-color-cobalt-default: var(--hsds-token-color-cobalt-500);
  --hsds-token-color-cobalt-accent: #47a3ffff;
  --hsds-token-color-cobalt-accent-rgb: 71,163,255;
  --hsds-token-color-purple-100: #f9f2ffff;
  --hsds-token-color-purple-100-rgb: 249,242,255;
  --hsds-token-color-purple-200: #f2e5ffff;
  --hsds-token-color-purple-200-rgb: 242,229,255;
  --hsds-token-color-purple-300: #d7baf5ff;
  --hsds-token-color-purple-300-rgb: 215,186,245;
  --hsds-token-color-purple-400: #ad82d8ff;
  --hsds-token-color-purple-400-rgb: 173,130,216;
  --hsds-token-color-purple-500: #9163bfff;
  --hsds-token-color-purple-500-rgb: 145,99,191;
  --hsds-token-color-purple-600: #774ba3ff;
  --hsds-token-color-purple-600-rgb: 119,75,163;
  --hsds-token-color-purple-700: #5d407aff;
  --hsds-token-color-purple-700-rgb: 93,64,122;
  --hsds-token-color-purple-800: #48335cff;
  --hsds-token-color-purple-800-rgb: 72,51,92;
  --hsds-token-color-purple-900: #31253dff;
  --hsds-token-color-purple-900-rgb: 49,37,61;
  --hsds-token-color-purple-1000: #271f2eff;
  --hsds-token-color-purple-1000-rgb: 39,31,46;
  --hsds-token-color-purple-default: var(--hsds-token-color-purple-500);
  --hsds-token-color-purple-accent: #c285ffff;
  --hsds-token-color-purple-accent-rgb: 194,133,255;
  --hsds-token-color-lilac-100: #fcf9ffff;
  --hsds-token-color-lilac-100-rgb: 252,249,255;
  --hsds-token-color-lilac-200: #ecdeffff;
  --hsds-token-color-lilac-200-rgb: 236,222,255;
  --hsds-token-color-lilac-300: #cda9ffff;
  --hsds-token-color-lilac-300-rgb: 205,169,255;
  --hsds-token-color-lilac-400: #ac6fffff;
  --hsds-token-color-lilac-400-rgb: 172,111,255;
  --hsds-token-color-lilac-500: #9747fcff;
  --hsds-token-color-lilac-500-rgb: 151,71,252;
  --hsds-token-color-lilac-600: #7935cfff;
  --hsds-token-color-lilac-600-rgb: 121,53,207;
  --hsds-token-color-lilac-700: #5e18b7ff;
  --hsds-token-color-lilac-700-rgb: 94,24,183;
  --hsds-token-color-lilac-800: #431379ff;
  --hsds-token-color-lilac-800-rgb: 67,19,121;
  --hsds-token-color-lilac-900: #361055ff;
  --hsds-token-color-lilac-900-rgb: 54,16,85;
  --hsds-token-color-lilac-1000: #220a33ff;
  --hsds-token-color-lilac-1000-rgb: 34,10,51;
  --hsds-token-color-lilac-default: var(--hsds-token-color-lilac-500);
  --hsds-token-color-lilac-accent: #7100ffff;
  --hsds-token-color-lilac-accent-rgb: 113,0,255;
  --hsds-token-color-magenta-100: #fff2f4ff;
  --hsds-token-color-magenta-100-rgb: 255,242,244;
  --hsds-token-color-magenta-200: #ffe5eaff;
  --hsds-token-color-magenta-200-rgb: 255,229,234;
  --hsds-token-color-magenta-300: #ffc7d3ff;
  --hsds-token-color-magenta-300-rgb: 255,199,211;
  --hsds-token-color-magenta-400: #e5859fff;
  --hsds-token-color-magenta-400-rgb: 229,133,159;
  --hsds-token-color-magenta-500: #bf5878ff;
  --hsds-token-color-magenta-500-rgb: 191,88,120;
  --hsds-token-color-magenta-600: #a34b6bff;
  --hsds-token-color-magenta-600-rgb: 163,75,107;
  --hsds-token-color-magenta-700: #863e5cff;
  --hsds-token-color-magenta-700-rgb: 134,62,92;
  --hsds-token-color-magenta-800: #5e3146ff;
  --hsds-token-color-magenta-800-rgb: 94,49,70;
  --hsds-token-color-magenta-900: #3d2531ff;
  --hsds-token-color-magenta-900-rgb: 61,37,49;
  --hsds-token-color-magenta-1000: #2e2126ff;
  --hsds-token-color-magenta-1000-rgb: 46,33,38;
  --hsds-token-color-magenta-default: var(--hsds-token-color-magenta-500);
  --hsds-token-color-magenta-accent: #ff5caaff;
  --hsds-token-color-magenta-accent-rgb: 255,92,170;
  --hsds-token-color-charcoal-100: #f9fafaff;
  --hsds-token-color-charcoal-100-rgb: 249,250,250;
  --hsds-token-color-charcoal-200: #f1f3f5ff;
  --hsds-token-color-charcoal-200-rgb: 241,243,245;
  --hsds-token-color-charcoal-300: #dfe6ebff;
  --hsds-token-color-charcoal-300-rgb: 223,230,235;
  --hsds-token-color-charcoal-400: #c8d3deff;
  --hsds-token-color-charcoal-400-rgb: 200,211,222;
  --hsds-token-color-charcoal-500: #abb9c7ff;
  --hsds-token-color-charcoal-500-rgb: 171,185,199;
  --hsds-token-color-charcoal-530: var(--hsds-token-color-charcoal-500);
  --hsds-token-color-charcoal-530-rgb: var(--hsds-token-color-charcoal-500-rgb);
  --hsds-token-color-charcoal-550: var(--hsds-token-color-charcoal-500);
  --hsds-token-color-charcoal-550-rgb: var(--hsds-token-color-charcoal-500-rgb);
  --hsds-token-color-charcoal-600: #7e8e9eff;
  --hsds-token-color-charcoal-600-rgb: 126,142,158;
  --hsds-token-color-charcoal-650: var(--hsds-token-color-charcoal-600);
  --hsds-token-color-charcoal-650-rgb: var(--hsds-token-color-charcoal-600-rgb);
  --hsds-token-color-charcoal-700: #556575ff;
  --hsds-token-color-charcoal-700-rgb: 85,101,117;
  --hsds-token-color-charcoal-800: #405261ff;
  --hsds-token-color-charcoal-800-rgb: 64,82,97;
  --hsds-token-color-charcoal-900: #314351ff;
  --hsds-token-color-charcoal-900-rgb: 49,67,81;
  --hsds-token-color-charcoal-1000: #253642ff;
  --hsds-token-color-charcoal-1000-rgb: 37,54,66;
  --hsds-token-color-charcoal-1100: #1d2b36ff;
  --hsds-token-color-charcoal-1100-rgb: 29,43,54;
  --hsds-token-color-charcoal-1200: #131b24ff;
  --hsds-token-color-charcoal-1200-rgb: 19,27,36;
  --hsds-token-color-charcoal-default: var(--hsds-token-color-charcoal-500);
  --hsds-token-color-clay-100: #faf8f7ff;
  --hsds-token-color-clay-100-rgb: 250,248,247;
  --hsds-token-color-clay-200: #f5f2f0ff;
  --hsds-token-color-clay-200-rgb: 245,242,240;
  --hsds-token-color-clay-300: #ede8e6ff;
  --hsds-token-color-clay-300-rgb: 237,232,230;
  --hsds-token-color-clay-400: #ded5d1ff;
  --hsds-token-color-clay-400-rgb: 222,213,209;
  --hsds-token-color-clay-500: #c2b4acff;
  --hsds-token-color-clay-500-rgb: 194,180,172;
  --hsds-token-color-clay-600: #9e8f88ff;
  --hsds-token-color-clay-600-rgb: 158,143,136;
  --hsds-token-color-clay-700: #8a7b74ff;
  --hsds-token-color-clay-700-rgb: 138,123,116;
  --hsds-token-color-clay-800: #756963ff;
  --hsds-token-color-clay-800-rgb: 117,105,99;
  --hsds-token-color-clay-900: #574f4bff;
  --hsds-token-color-clay-900-rgb: 87,79,75;
  --hsds-token-color-clay-1000: #4a4441ff;
  --hsds-token-color-clay-1000-rgb: 74,68,65;
  --hsds-token-color-clay-1100: #33302eff;
  --hsds-token-color-clay-1100-rgb: 51,48,46;
  --hsds-token-color-clay-1200: #262423ff;
  --hsds-token-color-clay-1200-rgb: 38,36,35;
  --hsds-token-color-clay-default: var(--hsds-token-color-clay-500);
  --hsds-token-color-functional-link-default: var(--hsds-token-color-cobalt-600);
  --hsds-token-color-functional-link-hovered: var(--hsds-token-color-cobalt-700);
  --hsds-token-color-functional-link-pressed: var(--hsds-token-color-cobalt-800);
  --hsds-token-color-functional-link-disabled: var(--hsds-token-color-charcoal-500);
  --hsds-token-color-functional-text-headline: var(--hsds-token-color-charcoal-1200);
  --hsds-token-color-functional-text-dark: var(--hsds-token-color-charcoal-900);
  --hsds-token-color-functional-text-default: var(--hsds-token-color-charcoal-800);
  --hsds-token-color-functional-text-light: var(--hsds-token-color-charcoal-700);
  --hsds-token-color-functional-success-text: var(--hsds-token-color-green-1000);
  --hsds-token-color-functional-success-icon: var(--hsds-token-color-green-500);
  --hsds-token-color-functional-success-border: var(--hsds-token-color-green-300);
  --hsds-token-color-functional-success-background: var(--hsds-token-color-green-100);
  --hsds-token-color-functional-error-text: var(--hsds-token-color-red-700);
  --hsds-token-color-functional-error-icon: var(--hsds-token-color-red-500);
  --hsds-token-color-functional-error-border: var(--hsds-token-color-red-300);
  --hsds-token-color-functional-error-background: var(--hsds-token-color-red-100);
  --hsds-token-color-functional-warning-text: var(--hsds-token-color-yellow-800);
  --hsds-token-color-functional-warning-icon: var(--hsds-token-color-yellow-400);
  --hsds-token-color-functional-warning-border: var(--hsds-token-color-yellow-200);
  --hsds-token-color-functional-warning-background: var(--hsds-token-color-yellow-100);
  --hsds-token-color-basics-white: #ffffffff;
  --hsds-token-color-basics-black: #000000ff;
  --hsds-token-color-basics-magenta: #ff00ffff;
  --hsds-token-color-basics-cyan: #00ffffff;
  --hsds-token-color-action-default: var(--hsds-token-color-cobalt-600);
  --hsds-token-color-action-base: var(--hsds-token-color-cobalt-600);
  --hsds-token-color-action-hover: var(--hsds-token-color-cobalt-700);
  --hsds-token-color-action-active: var(--hsds-token-color-cobalt-800);
  --hsds-token-color-action-focus: var(--hsds-token-color-cobalt-600);
  --hsds-token-color-action-disabled: var(--hsds-token-color-charcoal-800);
  --hsds-token-color-action-pressed: var(--hsds-token-color-action-active);
  --hsds-token-color-link-default: var(--hsds-token-color-action-default);
  --hsds-token-color-link-base: var(--hsds-token-color-action-base);
  --hsds-token-color-link-hover: var(--hsds-token-color-action-hover);
  --hsds-token-color-link-active: var(--hsds-token-color-action-active);
  --hsds-token-color-link-pressed: var(--hsds-token-color-action-active);
  --hsds-token-color-link-focus: var(--hsds-token-color-action-focus);
  --hsds-token-color-link-disabled: var(--hsds-token-color-action-disabled);
  --hsds-token-color-focusRing-default-innerColor: var(--hsds-token-color-cobalt-600);
  --hsds-token-color-focusRing-default-outerColor: rgba(121, 188, 255, 0.5);
  --hsds-token-color-focusRing-default-innerColorOverDark: var(--hsds-token-color-cobalt-accent);
  --hsds-token-color-focusRing-default-outerColorOverDark: var(--hsds-token-color-charcoal-900);
  --hsds-token-color-focusRing-error-innerColor: var(--hsds-token-color-state-error-borderColor);
  --hsds-token-color-focusRing-error-outerColor: var(--hsds-token-color-magenta-accent);
  --hsds-token-color-focusRing-error-innerColorOverDark: var(--hsds-token-color-state-error-borderColor);
  --hsds-token-color-focusRing-error-outerColorOverDark: var(--hsds-token-color-magenta-accent);
  --hsds-token-color-focusRing-warning-innerColor: var(--hsds-token-color-state-warning-borderColor);
  --hsds-token-color-focusRing-warning-outerColor: var(--hsds-token-color-state-warning-backgroundLight);
  --hsds-token-color-focusRing-warning-innerColorOverDark: var(--hsds-token-color-state-warning-borderColor);
  --hsds-token-color-focusRing-warning-outerColorOverDark: var(--hsds-token-color-state-warning-backgroundLight);
  --hsds-token-color-focusRing-success-innerColor: var(--hsds-token-color-state-success-borderColor);
  --hsds-token-color-focusRing-success-outerColor: var(--hsds-token-color-state-success-backgroundLight);
  --hsds-token-color-focusRing-success-innerColorOverDark: var(--hsds-token-color-state-success-borderColor);
  --hsds-token-color-focusRing-success-outerColorOverDark: var(--hsds-token-color-state-success-backgroundLight);
  --hsds-token-color-text-default: var(--hsds-token-color-charcoal-800);
  --hsds-token-color-text-headline: var(--hsds-token-color-charcoal-1200);
  --hsds-token-color-text-dark: var(--hsds-token-color-charcoal-900);
  --hsds-token-color-text-light: var(--hsds-token-color-charcoal-700);
  --hsds-token-color-text-disabled: var(--hsds-token-color-charcoal-600);
  --hsds-token-color-text-subtle: var(--hsds-token-color-text-default);
  --hsds-token-color-text-slightlyMuted: var(--hsds-token-color-text-light);
  --hsds-token-color-text-muted: var(--hsds-token-color-text-light);
  --hsds-token-color-text-faint: var(--hsds-token-color-text-disabled);
  --hsds-token-color-text-extraMuted: var(--hsds-token-color-charcoal-500);
  --hsds-token-color-border-default: var(--hsds-token-color-charcoal-300);
  --hsds-token-color-border-divider: var(--hsds-token-color-charcoal-200);
  --hsds-token-color-border-ui: var(--hsds-token-color-charcoal-500);
  --hsds-token-color-state-error-text: var(--hsds-token-color-red-600);
  --hsds-token-color-state-error-backgroundDark: var(--hsds-token-color-red-600);
  --hsds-token-color-state-error-icon: var(--hsds-token-color-red-500);
  --hsds-token-color-state-error-borderColor: var(--hsds-token-color-red-500);
  --hsds-token-color-state-error-backgroundLight: var(--hsds-token-color-red-100);
  --hsds-token-color-state-error-default: var(--hsds-token-color-red-600);
  --hsds-token-color-state-error-color: var(--hsds-token-color-red-600);
  --hsds-token-color-state-info-text: var(--hsds-token-color-cobalt-700);
  --hsds-token-color-state-info-backgroundDark: var(--hsds-token-color-cobalt-600);
  --hsds-token-color-state-info-icon: var(--hsds-token-color-cobalt-500);
  --hsds-token-color-state-info-borderColor: var(--hsds-token-color-cobalt-500);
  --hsds-token-color-state-info-backgroundLight: var(--hsds-token-color-cobalt-100);
  --hsds-token-color-state-info-default: var(--hsds-token-color-cobalt-700);
  --hsds-token-color-state-info-color: var(--hsds-token-color-cobalt-700);
  --hsds-token-color-state-success-text: var(--hsds-token-color-green-1000);
  --hsds-token-color-state-success-backgroundDark: var(--hsds-token-color-green-600);
  --hsds-token-color-state-success-icon: var(--hsds-token-color-green-500);
  --hsds-token-color-state-success-borderColor: var(--hsds-token-color-green-500);
  --hsds-token-color-state-success-backgroundLight: var(--hsds-token-color-green-100);
  --hsds-token-color-state-success-default: var(--hsds-token-color-green-1000);
  --hsds-token-color-state-success-color: var(--hsds-token-color-green-1000);
  --hsds-token-color-state-warning-text: var(--hsds-token-color-orange-600);
  --hsds-token-color-state-warning-backgroundDark: var(--hsds-token-color-orange-600);
  --hsds-token-color-state-warning-icon: var(--hsds-token-color-yellow-accent);
  --hsds-token-color-state-warning-borderColor: var(--hsds-token-color-yellow-400);
  --hsds-token-color-state-warning-backgroundLight: var(--hsds-token-color-yellow-100);
  --hsds-token-color-state-warning-color: var(--hsds-token-color-orange-600);
  --hsds-token-color-state-warning-default: var(--hsds-token-color-yellow-500);
  --hsds-token-color-state-danger-default: var(--hsds-token-color-state-error-default);
  --hsds-token-color-state-danger-backgroundLight: var(--hsds-token-color-state-error-backgroundLight);
  --hsds-token-color-state-danger-backgroundDark: var(--hsds-token-color-state-error-backgroundDark);
  --hsds-token-color-state-danger-borderColor: var(--hsds-token-color-state-error-borderColor);
  --hsds-token-color-state-danger-color: var(--hsds-token-color-state-error-color);
  --hsds-token-color-state-danger-text: var(--hsds-token-color-state-error-text);
  --hsds-token-color-state-danger-icon: var(--hsds-token-color-state-error-icon);
  --hsds-token-color-background-surface: #ffffffff;
  --hsds-token-color-background-body: var(--hsds-token-color-charcoal-100);
  --hsds-token-color-ai-light-default: var(--hsds-token-color-lilac-100);
  --hsds-token-color-ai-light-angle: linear-gradient(238deg, #FFA977 5.4%, #FF85DA 33.68%, #7D77FF 67.8%, #68ECE6 95.59%);
  --hsds-token-color-ai-light-linear: linear-gradient(180deg, #FFA977 0%, #FF85DA 50%, #7D77FF 100%);
  --hsds-token-color-ai-dark-default: var(--hsds-token-color-lilac-500);
  --hsds-token-color-ai-dark-angle: linear-gradient(122deg, #2835DB 18.41%, #AD4AFB 74.17%);
  --hsds-token-color-ai-dark-linear: linear-gradient(180deg, #2835DB 0%, #AD4AFB 100%);
  --hsds-token-color-pastel-light-blue: #ACE3FF;
  --hsds-token-color-pastel-light-green: #BCF1CA;
  --hsds-token-color-pastel-light-grey: #dfe6ebff;
  --hsds-token-color-pastel-light-purple: #DDCCFF;
  --hsds-token-color-pastel-light-red: #FFAFB1;
  --hsds-token-color-pastel-light-yellow: #FFE258;
  --hsds-token-color-pastel-light-teal: #A8F0EC;
  --hsds-token-color-pastel-light-pink: #FFCAFE;
  --hsds-token-color-pastel-light-orange: #FFBE6B;
  --hsds-token-color-pastel-light-creme: #FFFBF2;
  --hsds-token-color-pastel-dark-blue: #13AFFF;
  --hsds-token-color-pastel-dark-green: #3DD766;
  --hsds-token-color-pastel-dark-grey: #7C92A1;
  --hsds-token-color-pastel-dark-purple: #7733FF;
  --hsds-token-color-pastel-dark-red: #FF161C;
  --hsds-token-color-pastel-dark-yellow: #BE9D00;
  --hsds-token-color-pastel-dark-teal: #74B9B6;
  --hsds-token-color-pastel-dark-pink: #CB7ACA;
  --hsds-token-color-pastel-dark-orange: #C78B3D;
  --hsds-token-color-pastel-dark-creme: #FFFBF2;
  --hsds-token-font-family: "Aktiv Grotesk", "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  --hsds-token-font-system: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  --hsds-token-font-mono: "Roboto Mono", "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
  --hsds-token-font-size: 13px;
  --hsds-token-radius-small: 3px;
  --hsds-token-radius-default: 4px;
  --hsds-token-radius-elevation: 6px;
  --hsds-token-radius-block: 6px;
  --hsds-token-radius-global: 8px;
  --hsds-token-radius-input: 8px;
  --hsds-token-radius-page: 16px;
  --hsds-token-radius-table: 16px;
  --hsds-token-radius-bubble: 10px;
  --hsds-token-radius-overlay: 10px;
  --hsds-token-radius-circle: 100px;
  --hsds-token-shadow-50: 0px 1px 0px 0px rgba(49, 67, 81, 0.2);
  --hsds-token-shadow-100: 0px 4px 4px 0px rgba(0, 0, 0, 0.01), 0px 3px 3px 0px rgba(0, 0, 0, 0.02), 0px 2px 2px 0px rgba(0, 0, 0, 0.04), 0px 1px 0px 0px rgba(0, 0, 0, 0.09), 0px 0px 0px 1px rgba(6, 20, 34, 0.1);
  --hsds-token-shadow-200: 0px 4px 8px 0px rgba(0, 0, 0, 0.02),0px 3px 6px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.08),0px 1px 0px 0px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(6, 20, 34, 0.1);
  --hsds-token-shadow-400: 0px 0px 0px 1px rgba(49, 67, 81, 0.06), 0px 4px 12px 0px rgba(0, 0, 0, 0.08), 0px 4px 32px 0px rgba(0, 0, 0, 0.06);
  --hsds-token-shadow-500: 0px 0.35px 2.51px 0px rgba(0, 0, 0, 0.0194), 0px 1.58px 5.79px 0px rgba(0, 0, 0, 0.0307), 0px 3.93px 13.22px 0px rgba(0, 0, 0, 0.0393), 0px 7.65px 28.17px 0px rgba(0, 0, 0, 0.0506), 0px 13px 54px 0px rgba(0, 0, 0, 0.07), 0px 0px 0px 1px rgba(49, 67, 81, 0.2);
  --hsds-token-shadow-700: 0px 10px 40px 0px rgba(64, 82, 97, 0.3), 0px 2px 3px 0px rgba(64, 82, 97, 0.2);
  --hsds-token-shadow-inverted-50: 0px -1px 0px 0px rgba(49, 67, 81, 0.2);
  --hsds-token-zindex-tooltip: 100;
  --hsds-token-zindex-popover: 200;
  --hsds-token-zindex-droplist: 300;
  --hsds-token-zindex-overlay: 1000;
  --hsds-token-zindex-sidepanel: 2000;
  --hsds-token-zindex-modal: 3000;
  --hsds-token-zindex-notification: 20000;
  --hsds-token-zindex-debug: 999999999999999;
  --hsds-token-accordion-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-accordion-color-border: var(--hsds-token-color-charcoal-300);
  --hsds-token-accordion-color-text-default: var(--hsds-token-color-text-default);
  --hsds-token-accordion-color-title-text: var(--hsds-token-color-text-dark);
  --hsds-token-accordion-color-title-backgroundHover: var(--hsds-token-color-charcoal-100);
  --hsds-token-actionSelect-color-background: var(--hsds-token-color-charcoal-100);
  --hsds-token-actionSelect-color-border: var(--hsds-token-color-charcoal-500);
  --hsds-token-actionSelect-color-content-background: rgba(0, 0, 0, 0.05);
  --hsds-token-alert-color-error-text: var(--hsds-token-color-state-error-text);
  --hsds-token-alert-color-error-icon: var(--hsds-token-color-state-error-icon);
  --hsds-token-alert-color-error-borderColor: var(--hsds-token-color-state-error-borderColor);
  --hsds-token-alert-color-error-background: var(--hsds-token-color-state-error-backgroundLight);
  --hsds-token-alert-color-info-text: var(--hsds-token-color-state-info-text);
  --hsds-token-alert-color-info-icon: var(--hsds-token-color-state-info-icon);
  --hsds-token-alert-color-info-borderColor: var(--hsds-token-color-state-info-borderColor);
  --hsds-token-alert-color-info-background: var(--hsds-token-color-state-info-backgroundLight);
  --hsds-token-alert-color-success-text: var(--hsds-token-color-state-success-text);
  --hsds-token-alert-color-success-icon: var(--hsds-token-color-state-success-icon);
  --hsds-token-alert-color-success-borderColor: var(--hsds-token-color-state-success-borderColor);
  --hsds-token-alert-color-success-background: var(--hsds-token-color-state-success-backgroundLight);
  --hsds-token-alert-color-warning-text: var(--hsds-token-color-state-warning-text);
  --hsds-token-alert-color-warning-icon: var(--hsds-token-color-state-warning-icon);
  --hsds-token-alert-color-warning-borderColor: var(--hsds-token-color-state-warning-borderColor);
  --hsds-token-alert-color-warning-background: var(--hsds-token-color-state-warning-backgroundLight);
  --hsds-token-alert-color-ai-text: var(--hsds-token-color-purple-700);
  --hsds-token-alert-color-ai-icon: var(--hsds-token-color-purple-500);
  --hsds-token-alert-color-ai-borderColor: var(--hsds-token-color-ai-dark-default);
  --hsds-token-alert-color-ai-background: var(--hsds-token-color-purple-100);
  --hsds-token-attachment-color-text: var(--hsds-token-color-link-base);
  --hsds-token-attachment-color-bg: var(--hsds-token-color-background-surface);
  --hsds-token-attachment-color-border-default: var(--hsds-token-color-charcoal-400);
  --hsds-token-attachment-color-border-hover: var(--hsds-token-color-charcoal-500);
  --hsds-token-attachment-color-error: var(--hsds-token-color-red-600);
  --hsds-token-attachment-color-brokenButton-text: var(--hsds-token-color-text-light);
  --hsds-token-attachment-color-brokenButton-icon: var(--hsds-token-color-text-disabled);
  --hsds-token-attachment-color-downloadAll-icon: var(--hsds-token-color-text-disabled);
  --hsds-token-attachment-color-downloadAll-iconHover: var(--hsds-token-color-text-light);
  --hsds-token-attachment-color-downloadAll-backgroundHover: var(--hsds-token-color-charcoal-200);
  --hsds-token-avatar-color-initials-bg: var(--hsds-token-color-charcoal-300);
  --hsds-token-avatar-color-initials-text: var(--hsds-token-color-text-light);
  --hsds-token-avatar-color-initials-textLight: white;
  --hsds-token-avatar-color-initials-light: var(--hsds-token-color-charcoal-400);
  --hsds-token-avatar-color-circle-outer: var(--hsds-token-color-cobalt-200);
  --hsds-token-avatar-color-circle-inner: var(--hsds-token-color-cobalt-600);
  --hsds-token-badge-color-grey-default-bg: var(--hsds-token-color-charcoal-700);
  --hsds-token-badge-color-grey-default-text: #fff;
  --hsds-token-badge-color-grey-inverted-bg: var(--hsds-token-color-background-surface);
  --hsds-token-badge-color-grey-inverted-text: var(--hsds-token-color-charcoal-700);
  --hsds-token-badge-color-grey-inverted-border: var(--hsds-token-color-charcoal-300);
  --hsds-token-badge-color-grey-tone-bg: var(--hsds-token-color-charcoal-100);
  --hsds-token-badge-color-grey-tone-text: var(--hsds-token-color-charcoal-700);
  --hsds-token-badge-color-grey-tone-border: var(--hsds-token-color-charcoal-300);
  --hsds-token-badge-color-red-default-bg: var(--hsds-token-color-red-600);
  --hsds-token-badge-color-red-default-text: #fff;
  --hsds-token-badge-color-red-inverted-bg: var(--hsds-token-color-background-surface);
  --hsds-token-badge-color-red-inverted-text: var(--hsds-token-color-red-600);
  --hsds-token-badge-color-red-inverted-border: var(--hsds-token-color-red-500);
  --hsds-token-badge-color-red-tone-bg: var(--hsds-token-color-red-100);
  --hsds-token-badge-color-red-tone-text: var(--hsds-token-color-red-600);
  --hsds-token-badge-color-red-tone-border: var(--hsds-token-color-red-300);
  --hsds-token-badge-color-blue-default-bg: var(--hsds-token-color-cobalt-600);
  --hsds-token-badge-color-blue-default-text: #fff;
  --hsds-token-badge-color-blue-inverted-bg: var(--hsds-token-color-background-surface);
  --hsds-token-badge-color-blue-inverted-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-badge-color-blue-inverted-border: var(--hsds-token-color-cobalt-500);
  --hsds-token-badge-color-blue-tone-bg: var(--hsds-token-color-cobalt-100);
  --hsds-token-badge-color-blue-tone-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-badge-color-blue-tone-border: var(--hsds-token-color-cobalt-300);
  --hsds-token-badge-color-green-default-bg: var(--hsds-token-color-green-600);
  --hsds-token-badge-color-green-default-text: #fff;
  --hsds-token-badge-color-green-inverted-bg: var(--hsds-token-color-background-surface);
  --hsds-token-badge-color-green-inverted-text: var(--hsds-token-color-green-700);
  --hsds-token-badge-color-green-inverted-border: var(--hsds-token-color-green-500);
  --hsds-token-badge-color-green-tone-bg: var(--hsds-token-color-green-100);
  --hsds-token-badge-color-green-tone-text: var(--hsds-token-color-green-700);
  --hsds-token-badge-color-green-tone-border: var(--hsds-token-color-green-300);
  --hsds-token-badge-color-yellow-default-bg: var(--hsds-token-color-orange-600);
  --hsds-token-badge-color-yellow-default-text: #fff;
  --hsds-token-badge-color-yellow-inverted-bg: var(--hsds-token-color-background-surface);
  --hsds-token-badge-color-yellow-inverted-text: var(--hsds-token-color-orange-600);
  --hsds-token-badge-color-yellow-inverted-border: var(--hsds-token-color-yellow-400);
  --hsds-token-badge-color-yellow-tone-bg: var(--hsds-token-color-yellow-100);
  --hsds-token-badge-color-yellow-tone-text: var(--hsds-token-color-orange-600);
  --hsds-token-badge-color-yellow-tone-border: var(--hsds-token-color-yellow-300);
  --hsds-token-badge-color-purple-default-bg: var(--hsds-token-color-purple-600);
  --hsds-token-badge-color-purple-default-text: #fff;
  --hsds-token-badge-color-purple-inverted-bg: var(--hsds-token-color-background-surface);
  --hsds-token-badge-color-purple-inverted-text: var(--hsds-token-color-purple-700);
  --hsds-token-badge-color-purple-inverted-border: var(--hsds-token-color-purple-500);
  --hsds-token-badge-color-purple-tone-bg: var(--hsds-token-color-purple-100);
  --hsds-token-badge-color-purple-tone-text: var(--hsds-token-color-purple-700);
  --hsds-token-badge-color-purple-tone-border: var(--hsds-token-color-purple-300);
  --hsds-token-badge-color-ai-text: linear-gradient(121.57deg, #2835db 18.41%, #ad4afb 74.17%);
  --hsds-token-badge-color-ai-bg: var(--hsds-token-color-purple-accent);
  --hsds-token-badge-color-ai-gradient: linear-gradient(238.06deg, #ffa977 5.4%, #ff85da 33.68%, #7d77ff 67.8%,#68ece6 95.59%);
  --hsds-token-badgeCount-color-grey-text: var(--hsds-token-color-charcoal-800);
  --hsds-token-badgeCount-color-grey-border: var(--hsds-token-color-charcoal-400);
  --hsds-token-badgeCount-color-grey-bg: var(--hsds-token-color-charcoal-100);
  --hsds-token-badgeCount-color-white-bg: var(--hsds-token-color-background-surface);
  --hsds-token-badgeKeyboard-color-light-text: var(--hsds-token-color-text-default);
  --hsds-token-badgeKeyboard-color-light-bg: var(--hsds-token-color-charcoal-300);
  --hsds-token-badgeKeyboard-color-dark-text: #fff;
  --hsds-token-badgeKeyboard-color-dark-bg: var(--hsds-token-color-charcoal-700);
  --hsds-token-blankSlate-color-clay-heading: var(--hsds-token-color-clay-1100);
  --hsds-token-blankSlate-color-clay-text: var(--hsds-token-color-clay-900);
  --hsds-token-blankSlate-color-clay-textBold: var(--hsds-token-color-clay-1000);
  --hsds-token-blankSlate-color-clay-background: var(--hsds-token-color-clay-100);
  --hsds-token-blankSlate-color-clay-border: var(--hsds-token-color-clay-300);
  --hsds-token-blankSlate-color-charcoal-heading: var(--hsds-token-color-text-headline);
  --hsds-token-blankSlate-color-charcoal-text: var(--hsds-token-color-text-default);
  --hsds-token-blankSlate-color-charcoal-textBold: var(--hsds-token-color-text-default);
  --hsds-token-blankSlate-color-charcoal-background: var(--hsds-token-color-background-surface);
  --hsds-token-blankSlate-color-charcoal-border: var(--hsds-token-color-background-surface);
  --hsds-token-blankSlate-squircle-shadow: drop-shadow(0px 1.05px 1.5px #a270700e) drop-shadow(0px 4.8px 4.22px #a2707016) drop-shadow(0px 12.15px 11.33px #c2b5b514) drop-shadow(0px 24px 26px #a389891a);
  --hsds-token-button-color-blue-main: var(--hsds-token-color-cobalt-600);
  --hsds-token-button-color-blue-hover: var(--hsds-token-color-cobalt-700);
  --hsds-token-button-color-blue-text: #ffffffff;
  --hsds-token-button-color-blue-shortcut-background: var(--hsds-token-color-cobalt-700);
  --hsds-token-button-color-blue-shortcut-backgroundHover: var(--hsds-token-color-cobalt-800);
  --hsds-token-button-color-blue-linked-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-button-color-blue-linked-textHover: var(--hsds-token-color-cobalt-700);
  --hsds-token-button-color-blue-outlined-background: var(--hsds-token-color-background-surface);
  --hsds-token-button-color-blue-outlined-border: var(--hsds-token-color-cobalt-500);
  --hsds-token-button-color-blue-outlined-borderHover: var(--hsds-token-color-cobalt-500);
  --hsds-token-button-color-blue-outlined-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-button-color-blue-outlined-textHover: var(--hsds-token-color-cobalt-700);
  --hsds-token-button-color-blue-outlined-hover: var(--hsds-token-color-cobalt-100);
  --hsds-token-button-color-blue-outlined-textSeamlessHover: var(--hsds-token-color-cobalt-800);
  --hsds-token-button-color-blue-outlined-shortcut-background: var(--hsds-token-color-cobalt-200);
  --hsds-token-button-color-blue-outlined-shortcut-backgroundHover: var(--hsds-token-color-cobalt-200);
  --hsds-token-button-color-red-main: var(--hsds-token-color-red-600);
  --hsds-token-button-color-red-hover: var(--hsds-token-color-red-700);
  --hsds-token-button-color-red-text: #ffffffff;
  --hsds-token-button-color-red-shortcut-background: var(--hsds-token-color-red-700);
  --hsds-token-button-color-red-shortcut-backgroundHover: var(--hsds-token-color-red-800);
  --hsds-token-button-color-red-linked-text: var(--hsds-token-color-red-600);
  --hsds-token-button-color-red-linked-textHover: var(--hsds-token-color-red-700);
  --hsds-token-button-color-red-outlined-background: var(--hsds-token-color-background-surface);
  --hsds-token-button-color-red-outlined-border: var(--hsds-token-color-red-500);
  --hsds-token-button-color-red-outlined-borderHover: var(--hsds-token-color-red-500);
  --hsds-token-button-color-red-outlined-text: var(--hsds-token-color-red-600);
  --hsds-token-button-color-red-outlined-textHover: var(--hsds-token-color-red-700);
  --hsds-token-button-color-red-outlined-hover: var(--hsds-token-color-red-100);
  --hsds-token-button-color-red-outlined-textSeamlessHover: var(--hsds-token-color-red-700);
  --hsds-token-button-color-red-outlined-shortcut-background: var(--hsds-token-color-red-200);
  --hsds-token-button-color-red-outlined-shortcut-backgroundHover: var(--hsds-token-color-red-200);
  --hsds-token-button-color-green-main: var(--hsds-token-color-green-600);
  --hsds-token-button-color-green-hover: var(--hsds-token-color-green-700);
  --hsds-token-button-color-green-text: #ffffffff;
  --hsds-token-button-color-green-shortcut-background: var(--hsds-token-color-green-700);
  --hsds-token-button-color-green-shortcut-backgroundHover: var(--hsds-token-color-green-1000);
  --hsds-token-button-color-green-linked-text: var(--hsds-token-color-green-1000);
  --hsds-token-button-color-green-linked-textHover: var(--hsds-token-color-green-1000);
  --hsds-token-button-color-green-outlined-background: var(--hsds-token-color-background-surface);
  --hsds-token-button-color-green-outlined-border: var(--hsds-token-color-green-500);
  --hsds-token-button-color-green-outlined-borderHover: var(--hsds-token-color-green-500);
  --hsds-token-button-color-green-outlined-text: var(--hsds-token-color-green-1000);
  --hsds-token-button-color-green-outlined-textHover: var(--hsds-token-color-green-1000);
  --hsds-token-button-color-green-outlined-hover: var(--hsds-token-color-green-100);
  --hsds-token-button-color-green-outlined-textSeamlessHover: var(--hsds-token-color-green-1000);
  --hsds-token-button-color-green-outlined-shortcut-background: var(--hsds-token-color-green-200);
  --hsds-token-button-color-green-outlined-shortcut-backgroundHover: var(--hsds-token-color-green-200);
  --hsds-token-button-color-grey-main: var(--hsds-token-color-charcoal-600);
  --hsds-token-button-color-grey-hover: var(--hsds-token-color-charcoal-700);
  --hsds-token-button-color-grey-text: #ffffffff;
  --hsds-token-button-color-grey-shortcut-background: var(--hsds-token-color-charcoal-700);
  --hsds-token-button-color-grey-shortcut-backgroundHover: var(--hsds-token-color-charcoal-800);
  --hsds-token-button-color-grey-linked-text: var(--hsds-token-color-charcoal-800);
  --hsds-token-button-color-grey-linked-textHover: var(--hsds-token-color-charcoal-800);
  --hsds-token-button-color-grey-outlined-background: var(--hsds-token-color-background-surface);
  --hsds-token-button-color-grey-outlined-border: var(--hsds-token-color-charcoal-400);
  --hsds-token-button-color-grey-outlined-borderHover: var(--hsds-token-color-charcoal-500);
  --hsds-token-button-color-grey-outlined-text: var(--hsds-token-color-charcoal-800);
  --hsds-token-button-color-grey-outlined-textHover: var(--hsds-token-color-charcoal-800);
  --hsds-token-button-color-grey-outlined-hover: var(--hsds-token-color-charcoal-100);
  --hsds-token-button-color-grey-outlined-textSeamlessHover: var(--hsds-token-color-charcoal-1100);
  --hsds-token-button-color-grey-outlined-shortcut-background: var(--hsds-token-color-charcoal-200);
  --hsds-token-button-color-grey-outlined-shortcut-backgroundHover: var(--hsds-token-color-charcoal-200);
  --hsds-token-button-color-yellow-main: var(--hsds-token-color-orange-600);
  --hsds-token-button-color-yellow-hover: var(--hsds-token-color-orange-700);
  --hsds-token-button-color-yellow-text: #ffffffff;
  --hsds-token-button-color-yellow-shortcut-background: var(--hsds-token-color-orange-700);
  --hsds-token-button-color-yellow-shortcut-backgroundHover: var(--hsds-token-color-orange-800);
  --hsds-token-button-color-yellow-linked-text: var(--hsds-token-color-orange-600);
  --hsds-token-button-color-yellow-linked-textHover: var(--hsds-token-color-orange-700);
  --hsds-token-button-color-yellow-outlined-background: var(--hsds-token-color-background-surface);
  --hsds-token-button-color-yellow-outlined-border: var(--hsds-token-color-state-warning-borderColor);
  --hsds-token-button-color-yellow-outlined-borderHover: var(--hsds-token-color-yellow-500);
  --hsds-token-button-color-yellow-outlined-text: var(--hsds-token-color-orange-600);
  --hsds-token-button-color-yellow-outlined-textHover: var(--hsds-token-color-orange-700);
  --hsds-token-button-color-yellow-outlined-hover: var(--hsds-token-color-yellow-100);
  --hsds-token-button-color-yellow-outlined-textSeamlessHover: var(--hsds-token-color-orange-700);
  --hsds-token-button-color-yellow-outlined-shortcut-background: var(--hsds-token-color-yellow-200);
  --hsds-token-button-color-yellow-outlined-shortcut-backgroundHover: var(--hsds-token-color-yellow-200);
  --hsds-token-button-color-purple-main: var(--hsds-token-color-purple-500);
  --hsds-token-button-color-purple-hover: var(--hsds-token-color-purple-600);
  --hsds-token-button-color-purple-text: #ffffffff;
  --hsds-token-button-color-purple-shortcut-background: var(--hsds-token-color-purple-700);
  --hsds-token-button-color-purple-shortcut-backgroundHover: var(--hsds-token-color-purple-800);
  --hsds-token-button-color-purple-linked-text: var(--hsds-token-color-purple-600);
  --hsds-token-button-color-purple-linked-textHover: var(--hsds-token-color-purple-700);
  --hsds-token-button-color-purple-outlined-background: var(--hsds-token-color-background-surface);
  --hsds-token-button-color-purple-outlined-border: var(--hsds-token-color-purple-600);
  --hsds-token-button-color-purple-outlined-borderHover: var(--hsds-token-color-purple-600);
  --hsds-token-button-color-purple-outlined-text: var(--hsds-token-color-purple-600);
  --hsds-token-button-color-purple-outlined-textHover: var(--hsds-token-color-purple-700);
  --hsds-token-button-color-purple-outlined-hover: var(--hsds-token-color-purple-100);
  --hsds-token-button-color-purple-outlined-textSeamlessHover: var(--hsds-token-color-purple-800);
  --hsds-token-button-color-purple-outlined-shortcut-background: var(--hsds-token-color-purple-200);
  --hsds-token-button-color-purple-outlined-shortcut-backgroundHover: var(--hsds-token-color-purple-200);
  --hsds-token-button-color-aiPurple-main: var(--hsds-token-color-ai-dark-default);
  --hsds-token-button-color-aiPurple-hover: var(--hsds-token-color-lilac-600);
  --hsds-token-button-color-aiPurple-text: #ffffffff;
  --hsds-token-button-color-aiPurple-shortcut-background: var(--hsds-token-color-lilac-600);
  --hsds-token-button-color-aiPurple-shortcut-backgroundHover: var(--hsds-token-color-lilac-700);
  --hsds-token-button-color-aiPurple-linked-text: var(--hsds-token-color-ai-dark-default);
  --hsds-token-button-color-aiPurple-linked-textHover: var(--hsds-token-color-lilac-600);
  --hsds-token-button-color-aiPurple-outlined-background: var(--hsds-token-color-background-surface);
  --hsds-token-button-color-aiPurple-outlined-border: var(--hsds-token-color-ai-dark-default);
  --hsds-token-button-color-aiPurple-outlined-borderHover: var(--hsds-token-color-lilac-600);
  --hsds-token-button-color-aiPurple-outlined-text: var(--hsds-token-color-ai-dark-default);
  --hsds-token-button-color-aiPurple-outlined-textHover: var(--hsds-token-color-lilac-600);
  --hsds-token-button-color-aiPurple-outlined-hover: var(--hsds-token-color-ai-light-default);
  --hsds-token-button-color-aiPurple-outlined-textSeamlessHover: var(--hsds-token-color-lilac-700);
  --hsds-token-button-color-aiPurple-outlined-shortcut-background: var(--hsds-token-color-ai-light-default);
  --hsds-token-button-color-aiPurple-outlined-shortcut-backgroundHover: var(--hsds-token-color-ai-light-default);
  --hsds-token-button-color-greenLight-main: var(--hsds-token-color-green-200);
  --hsds-token-button-color-greenLight-hover: var(--hsds-token-color-green-300);
  --hsds-token-button-color-greenLight-text: var(--hsds-token-color-green-1000);
  --hsds-token-button-color-greenLight-outlined-background: var(--hsds-token-button-color-green-outlined-background);
  --hsds-token-button-color-greenLight-outlined-border: var(--hsds-token-button-color-green-outlined-border);
  --hsds-token-button-color-greenLight-outlined-borderHover: var(--hsds-token-button-color-green-outlined-borderHover);
  --hsds-token-button-color-greenLight-outlined-text: var(--hsds-token-button-color-green-outlined-text);
  --hsds-token-button-color-greenLight-outlined-textHover: var(--hsds-token-button-color-green-outlined-textHover);
  --hsds-token-button-color-greenLight-outlined-hover: var(--hsds-token-button-color-green-outlined-hover);
  --hsds-token-button-color-greenLight-outlined-textSeamlessHover: var(--hsds-token-button-color-green-outlined-textSeamlessHover);
  --hsds-token-button-color-greenLight-outlined-shortcut-background: var(--hsds-token-button-color-green-outlined-shortcut-background);
  --hsds-token-button-color-greenLight-outlined-shortcut-backgroundHover: var(--hsds-token-button-color-green-outlined-shortcut-backgroundHover);
  --hsds-token-button-color-greyLight-main: var(--hsds-token-color-charcoal-200);
  --hsds-token-button-color-greyLight-hover: var(--hsds-token-color-charcoal-300);
  --hsds-token-button-color-greyLight-text: var(--hsds-token-color-text-headline);
  --hsds-token-button-color-greyLight-outlined-background: var(--hsds-token-button-color-grey-outlined-background);
  --hsds-token-button-color-greyLight-outlined-border: var(--hsds-token-button-color-grey-outlined-border);
  --hsds-token-button-color-greyLight-outlined-borderHover: var(--hsds-token-button-color-grey-outlined-borderHover);
  --hsds-token-button-color-greyLight-outlined-text: var(--hsds-token-button-color-grey-outlined-text);
  --hsds-token-button-color-greyLight-outlined-textHover: var(--hsds-token-button-color-grey-outlined-textHover);
  --hsds-token-button-color-greyLight-outlined-hover: var(--hsds-token-button-color-grey-outlined-hover);
  --hsds-token-button-color-greyLight-outlined-textSeamlessHover: var(--hsds-token-button-color-grey-outlined-textSeamlessHover);
  --hsds-token-button-color-greyLight-outlined-shortcut-background: var(--hsds-token-button-color-grey-outlined-shortcut-background);
  --hsds-token-button-color-greyLight-outlined-shortcut-backgroundHover: var(--hsds-token-button-color-grey-outlined-shortcut-backgroundHover);
  --hsds-token-button-color-blueLight-main: var(--hsds-token-color-cobalt-100);
  --hsds-token-button-color-blueLight-hover: var(--hsds-token-color-cobalt-200);
  --hsds-token-button-color-blueLight-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-button-color-blueLight-outlined-background: var(--hsds-token-button-color-blue-outlined-background);
  --hsds-token-button-color-blueLight-outlined-border: var(--hsds-token-button-color-blue-outlined-border);
  --hsds-token-button-color-blueLight-outlined-borderHover: var(--hsds-token-button-color-blue-outlined-borderHover);
  --hsds-token-button-color-blueLight-outlined-text: var(--hsds-token-button-color-blue-outlined-text);
  --hsds-token-button-color-blueLight-outlined-textHover: var(--hsds-token-button-color-blue-outlined-textHover);
  --hsds-token-button-color-blueLight-outlined-hover: var(--hsds-token-button-color-blue-outlined-hover);
  --hsds-token-button-color-blueLight-outlined-textSeamlessHover: var(--hsds-token-button-color-blue-outlined-textSeamlessHover);
  --hsds-token-button-color-blueLight-outlined-shortcut-background: var(--hsds-token-button-color-blue-outlined-shortcut-background);
  --hsds-token-button-color-blueLight-outlined-shortcut-backgroundHover: var(--hsds-token-button-color-blue-outlined-shortcut-backgroundHover);
  --hsds-token-button-color-blueAccent-main: var(--hsds-token-color-cobalt-200);
  --hsds-token-button-color-blueAccent-hover: var(--hsds-token-color-cobalt-300);
  --hsds-token-button-color-blueAccent-text: var(--hsds-token-color-text-headline);
  --hsds-token-button-color-blueAccent-outlined-background: var(--hsds-token-button-color-blue-outlined-background);
  --hsds-token-button-color-blueAccent-outlined-border: var(--hsds-token-button-color-blue-outlined-border);
  --hsds-token-button-color-blueAccent-outlined-borderHover: var(--hsds-token-button-color-blue-outlined-borderHover);
  --hsds-token-button-color-blueAccent-outlined-text: var(--hsds-token-button-color-blue-outlined-text);
  --hsds-token-button-color-blueAccent-outlined-textHover: var(--hsds-token-button-color-blue-outlined-textHover);
  --hsds-token-button-color-blueAccent-outlined-hover: var(--hsds-token-button-color-blue-outlined-hover);
  --hsds-token-button-color-blueAccent-outlined-textSeamlessHover: var(--hsds-token-button-color-blue-outlined-textSeamlessHover);
  --hsds-token-button-color-blueAccent-outlined-shortcut-background: var(--hsds-token-button-color-blue-outlined-shortcut-background);
  --hsds-token-button-color-blueAccent-outlined-shortcut-backgroundHover: var(--hsds-token-button-color-blue-outlined-shortcut-backgroundHover);
  --hsds-token-button-color-redAccent-main: var(--hsds-token-color-magenta-300);
  --hsds-token-button-color-redAccent-hover: #FFB3C3;
  --hsds-token-button-color-redAccent-text: var(--hsds-token-color-text-headline);
  --hsds-token-button-color-redAccent-outlined-background: var(--hsds-token-button-color-red-outlined-background);
  --hsds-token-button-color-redAccent-outlined-border: var(--hsds-token-button-color-red-outlined-border);
  --hsds-token-button-color-redAccent-outlined-borderHover: var(--hsds-token-button-color-red-outlined-borderHover);
  --hsds-token-button-color-redAccent-outlined-text: var(--hsds-token-button-color-red-outlined-text);
  --hsds-token-button-color-redAccent-outlined-textHover: var(--hsds-token-button-color-red-outlined-textHover);
  --hsds-token-button-color-redAccent-outlined-hover: var(--hsds-token-button-color-red-outlined-hover);
  --hsds-token-button-color-redAccent-outlined-textSeamlessHover: var(--hsds-token-button-color-red-outlined-textSeamlessHover);
  --hsds-token-button-color-redAccent-outlined-shortcut-background: var(--hsds-token-button-color-red-outlined-shortcut-background);
  --hsds-token-button-color-redAccent-outlined-shortcut-backgroundHover: var(--hsds-token-button-color-red-outlined-shortcut-backgroundHover);
  --hsds-token-button-color-greenAccent-main: var(--hsds-token-color-green-accent);
  --hsds-token-button-color-greenAccent-hover: #31E284;
  --hsds-token-button-color-greenAccent-text: var(--hsds-token-color-text-headline);
  --hsds-token-button-color-greenAccent-outlined-background: var(--hsds-token-button-color-green-outlined-background);
  --hsds-token-button-color-greenAccent-outlined-border: var(--hsds-token-button-color-green-outlined-border);
  --hsds-token-button-color-greenAccent-outlined-borderHover: var(--hsds-token-button-color-green-outlined-borderHover);
  --hsds-token-button-color-greenAccent-outlined-text: var(--hsds-token-button-color-green-outlined-text);
  --hsds-token-button-color-greenAccent-outlined-textHover: var(--hsds-token-button-color-green-outlined-textHover);
  --hsds-token-button-color-greenAccent-outlined-hover: var(--hsds-token-button-color-green-outlined-hover);
  --hsds-token-button-color-greenAccent-outlined-textSeamlessHover: var(--hsds-token-button-color-green-outlined-textSeamlessHover);
  --hsds-token-button-color-greenAccent-outlined-shortcut-background: var(--hsds-token-button-color-green-outlined-shortcut-background);
  --hsds-token-button-color-greenAccent-outlined-shortcut-backgroundHover: var(--hsds-token-button-color-green-outlined-shortcut-backgroundHover);
  --hsds-token-button-color-disabled-main: var(--hsds-token-color-charcoal-500);
  --hsds-token-button-color-disabled-text: #ffffffff;
  --hsds-token-button-color-disabled-outlined-background: var(--hsds-token-color-background-surface);
  --hsds-token-button-color-disabled-outlined-border: var(--hsds-token-color-charcoal-500);
  --hsds-token-button-color-disabled-outlined-text: var(--hsds-token-color-charcoal-500);
  --hsds-token-button-color-disabled-outlined-shortcut-background: var(--hsds-token-color-charcoal-200);
  --hsds-token-button-color-disabled-outlined-shortcut-text: var(--hsds-token-color-text-disabled);
  --hsds-token-button-color-disabled-shortcut-background: var(--hsds-token-color-charcoal-600);
  --hsds-token-button-color-disabled-shortcut-text: var(--hsds-token-color-basics-white);
  --hsds-token-button-radius-small: 6px;
  --hsds-token-button-radius-default: var(--hsds-token-radius-global);
  --hsds-token-buttonIcon-color-green-main: var(--hsds-token-color-green-200);
  --hsds-token-buttonIcon-color-green-hover: var(--hsds-token-color-green-300);
  --hsds-token-buttonIcon-color-green-text: var(--hsds-token-color-charcoal-900);
  --hsds-token-buttonIcon-color-green-textHover: var(--hsds-token-color-charcoal-1000);
  --hsds-token-buttonIcon-color-grey-main: var(--hsds-token-color-charcoal-200);
  --hsds-token-buttonIcon-color-grey-hover: var(--hsds-token-color-charcoal-300);
  --hsds-token-buttonIcon-color-grey-text: var(--hsds-token-color-charcoal-900);
  --hsds-token-buttonIcon-color-grey-textHover: var(--hsds-token-color-charcoal-1000);
  --hsds-token-buttonIcon-color-purple-main: var(--hsds-token-color-purple-200);
  --hsds-token-buttonIcon-color-purple-hover: var(--hsds-token-color-purple-300);
  --hsds-token-buttonIcon-color-purple-text: var(--hsds-token-color-purple-600);
  --hsds-token-buttonIcon-color-purple-textHover: var(--hsds-token-color-purple-700);
  --hsds-token-buttonIcon-color-white-main: var(--hsds-token-color-background-surface);
  --hsds-token-buttonIcon-color-white-hover: var(--hsds-token-color-charcoal-200);
  --hsds-token-buttonIcon-color-white-text: var(--hsds-token-color-charcoal-900);
  --hsds-token-buttonIcon-color-white-textHover: var(--hsds-token-color-charcoal-1000);
  --hsds-token-buttonIcon-color-blue-main: var(--hsds-token-color-link-default);
  --hsds-token-buttonIcon-color-blue-hover: var(--hsds-token-color-link-hover);
  --hsds-token-buttonIcon-color-blue-text: var(--hsds-token-color-background-surface);
  --hsds-token-buttonIcon-color-blue-textHover: var(--hsds-token-color-background-surface);
  --hsds-token-buttonIcon-color-charcoal-main: var(--hsds-token-color-charcoal-1200);
  --hsds-token-buttonIcon-color-charcoal-hover: var(--hsds-token-color-charcoal-900);
  --hsds-token-buttonIcon-color-charcoal-text: var(--hsds-token-color-charcoal-400);
  --hsds-token-buttonIcon-color-charcoal-textHover: white;
  --hsds-token-buttonIcon-color-clay-main: var(--hsds-token-color-clay-200);
  --hsds-token-buttonIcon-color-clay-hover: white;
  --hsds-token-buttonIcon-color-clay-text: var(--hsds-token-color-clay-1000);
  --hsds-token-buttonIcon-color-clay-textHover: var(--hsds-token-color-clay-1100);
  --hsds-token-buttonIcon-color-disabled-border: var(--hsds-token-color-charcoal-400);
  --hsds-token-buttonIcon-color-disabled-main: var(--hsds-token-color-background-surface);
  --hsds-token-buttonIcon-color-disabled-text: var(--hsds-token-color-charcoal-400);
  --hsds-token-card-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-card-border-default-width: 1px;
  --hsds-token-card-border-default-color: var(--hsds-token-color-charcoal-300);
  --hsds-token-card-border-clickable-color: var(--hsds-token-color-charcoal-400);
  --hsds-token-card-border-clickable-hover-color: var(--hsds-token-color-charcoal-500);
  --hsds-token-chip-color-default-background: var(--hsds-token-color-background-surface);
  --hsds-token-chip-color-default-border: var(--hsds-token-color-charcoal-400);
  --hsds-token-chip-color-default-text: var(--hsds-token-color-text-dark);
  --hsds-token-chip-hover-default: var(--hsds-token-color-charcoal-100);
  --hsds-token-chip-hover-red: var(--hsds-token-color-red-200);
  --hsds-token-chip-hover-green: var(--hsds-token-color-green-200);
  --hsds-token-chip-hover-yellow: var(--hsds-token-color-yellow-200);
  --hsds-token-chip-hover-blue: var(--hsds-token-color-cobalt-200);
  --hsds-token-chip-pill-default: var(--hsds-token-color-charcoal-300);
  --hsds-token-chip-pill-blue: var(--hsds-token-color-pastel-light-blue);
  --hsds-token-chip-pill-green: var(--hsds-token-color-pastel-light-green);
  --hsds-token-chip-pill-red: var(--hsds-token-color-pastel-light-red);
  --hsds-token-chip-pill-yellow: var(--hsds-token-color-pastel-light-yellow);
  --hsds-token-choice-color-icon-disabled: var(--hsds-token-color-charcoal-500);
  --hsds-token-choice-color-placeholder-disabled: var(--hsds-token-color-charcoal-500);
  --hsds-token-choice-color-backdrop-customRadio-bg: var(--hsds-token-color-charcoal-400);
  --hsds-token-choice-color-backdrop-selectedFilled-bg: var(--hsds-token-color-cobalt-600);
  --hsds-token-choice-color-backdrop-selectedFilled-border: var(--hsds-token-color-cobalt-600);
  --hsds-token-choice-color-backdrop-disabled-bg: var(--hsds-token-color-charcoal-200);
  --hsds-token-closeButton-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-condition-color-background: var(--hsds-token-color-charcoal-100);
  --hsds-token-condition-color-border: #d5dce1;
  --hsds-token-condition-color-operator-background: var(--hsds-token-color-charcoal-500);
  --hsds-token-condition-color-text: var(--hsds-token-color-text-subtle);
  --hsds-token-condition-color-selected-text: var(--hsds-token-color-text-dark);
  --hsds-token-convoStatusSymbol-color-active-outer: var(--hsds-token-color-green-500);
  --hsds-token-convoStatusSymbol-color-active-inner: var(--hsds-token-color-green-300);
  --hsds-token-convoStatusSymbol-color-pending-outer: var(--hsds-token-color-cobalt-500);
  --hsds-token-convoStatusSymbol-color-pending-inner: var(--hsds-token-color-cobalt-300);
  --hsds-token-convoStatusSymbol-color-closed-outer: var(--hsds-token-color-charcoal-400);
  --hsds-token-convoStatusSymbol-color-closed-inner: var(--hsds-token-color-charcoal-700);
  --hsds-token-convoStatusSymbol-color-spam-outer: var(--hsds-token-color-red-500);
  --hsds-token-convoStatusSymbol-color-spam-inner: var(--hsds-token-color-red-300);
  --hsds-token-copyCode-color-selection: var(--hsds-token-color-cobalt-200);
  --hsds-token-copyCode-color-boxShadow: var(--hsds-token-color-charcoal-500);
  --hsds-token-copyValue-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-copyValue-color-icon: var(--hsds-token-color-text-default);
  --hsds-token-copyValue-color-text: var(--hsds-token-color-text-light);
  --hsds-token-copyValue-color-prefix: var(--hsds-token-color-charcoal-500);
  --hsds-token-copyValue-color-button-mainColor: var(--hsds-token-color-cobalt-600);
  --hsds-token-copyValue-color-button-color: #fff;
  --hsds-token-datePicker-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-datePicker-color-day-background: var(--hsds-token-color-background-surface);
  --hsds-token-datePicker-color-day-text: var(--hsds-token-color-text-default);
  --hsds-token-datePicker-color-day-disabled: var(--hsds-token-color-text-disabled);
  --hsds-token-datePicker-color-day-hover-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-datePicker-color-day-current-background: var(--hsds-token-color-charcoal-200);
  --hsds-token-datePicker-color-day-current-text: var(--hsds-token-color-text-dark);
  --hsds-token-datePicker-color-day-selected-background: var(--hsds-token-color-cobalt-600);
  --hsds-token-datePicker-color-day-selected-text: #ffffff;
  --hsds-token-datePicker-color-day-range-background: var(--hsds-token-color-cobalt-100);
  --hsds-token-datePicker-color-day-range-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-datePicker-color-day-anotherMonth: #fff;
  --hsds-token-datePicker-color-weekdays-text: var(--hsds-token-color-text-dark);
  --hsds-token-datePicker-color-deepNavigatorButton-background: var(--hsds-token-color-background-surface);
  --hsds-token-datePicker-color-deepNavigatorButton-text: var(--hsds-token-color-charcoal-1200);
  --hsds-token-datePicker-color-deepNavigatorButton-border: #ffffff00;
  --hsds-token-datePicker-color-deepNavigatorButton-hover-background: var(--hsds-token-color-cobalt-100);
  --hsds-token-datePicker-color-deepNavigatorButton-hover-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-datePicker-color-deepNavigatorButton-hover-border: var(--hsds-token-color-cobalt-100);
  --hsds-token-datePicker-color-sequentialNavButton-background: #ffffff00;
  --hsds-token-datePicker-color-sequentialNavButton-text: var(--hsds-token-color-text-default);
  --hsds-token-datePicker-color-sequentialNavButton-border: #ffffff00;
  --hsds-token-datePicker-color-sequentialNavButton-disabled: var(--hsds-token-color-text-disabled);
  --hsds-token-datePicker-color-sequentialNavButton-hover-background: var(--hsds-token-color-cobalt-100);
  --hsds-token-datePicker-color-sequentialNavButton-hover-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-datePicker-color-sequentialNavButton-hover-border: var(--hsds-token-color-cobalt-100);
  --hsds-token-datePicker-color-periodButton-background: var(--hsds-token-color-background-surface);
  --hsds-token-datePicker-color-periodButton-text: var(--hsds-token-color-text-default);
  --hsds-token-datePicker-color-periodButton-border: #ffffff00;
  --hsds-token-datePicker-color-periodButton-current-background: var(--hsds-token-color-charcoal-200);
  --hsds-token-datePicker-color-periodButton-current-text: var(--hsds-token-color-text-dark);
  --hsds-token-datePicker-color-periodButton-selected-background: var(--hsds-token-color-cobalt-600);
  --hsds-token-datePicker-color-periodButton-selected-text: #ffffff;
  --hsds-token-datePicker-color-periodButton-selected-hover-background: var(--hsds-token-color-cobalt-100);
  --hsds-token-datePicker-color-periodButton-selected-hover-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-datePicker-color-periodButton-selected-hover-border: var(--hsds-token-color-cobalt-100);
  --hsds-token-datePicker-color-periodButton-disabled: var(--hsds-token-color-text-disabled);
  --hsds-token-dotStepper-color-bullet: var(--hsds-token-color-charcoal-400);
  --hsds-token-dotStepper-color-bulletCurrent: var(--hsds-token-color-green-500);
  --hsds-token-dotStepper-color-bulletProgress: var(--hsds-token-color-green-300);
  --hsds-token-dropList-color-wrapper-border: var(--hsds-token-color-charcoal-500);
  --hsds-token-dropList-color-wrapper-text: var(--hsds-token-color-charcoal-500);
  --hsds-token-dropList-color-icon: var(--hsds-token-color-charcoal-600);
  --hsds-token-dropList-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-dropList-color-input-text: var(--hsds-token-color-charcoal-900);
  --hsds-token-dropList-color-input-placeholder: var(--hsds-token-color-text-light);
  --hsds-token-dropList-color-listItem-text: var(--hsds-token-color-text-dark);
  --hsds-token-dropList-color-listItem-title: var(--hsds-token-color-text-headline);
  --hsds-token-dropList-color-listItem-subtitle: var(--hsds-token-color-text-light);
  --hsds-token-dropList-color-listItem-disabled-text: var(--hsds-token-color-text-disabled);
  --hsds-token-dropList-color-listItem-action-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-dropList-color-listItem-selected-text: #ffffffff;
  --hsds-token-dropList-color-listItem-selected-title: #ffffffff;
  --hsds-token-dropList-color-listItem-selected-subtitle: var(--hsds-token-color-cobalt-200);
  --hsds-token-dropList-color-listItem-selected-background: var(--hsds-token-color-cobalt-600);
  --hsds-token-dropList-color-listItem-icon-default: var(--hsds-token-color-charcoal-900);
  --hsds-token-dropList-color-listItem-icon-hover: var(--hsds-token-color-charcoal-1000);
  --hsds-token-dropList-color-listItem-highlighted-text: var(--hsds-token-color-text-headline);
  --hsds-token-dropList-color-listItem-highlighted-subtitle: var(--hsds-token-color-text-default);
  --hsds-token-dropList-color-listItem-highlighted-background: var(--hsds-token-color-charcoal-200);
  --hsds-token-dropList-color-listItem-multiple-highlighted-text: var(--hsds-token-color-charcoal-1000);
  --hsds-token-dropList-color-selectedBadge-border: var(--hsds-token-color-charcoal-500);
  --hsds-token-dropList-color-selectedBadge-hover: var(--hsds-token-color-cobalt-600);
  --hsds-token-dropList-color-selectedBadge-disabled-border: var(--hsds-token-color-charcoal-500);
  --hsds-token-dropList-color-selectedBadge-disabled-shadow: var(--hsds-token-color-charcoal-400);
  --hsds-token-dropList-color-selectedBadge-disabled-background: var(--hsds-token-color-charcoal-100);
  --hsds-token-dropList-color-divider: var(--hsds-token-color-charcoal-200);
  --hsds-token-dropList-color-groupLabel: var(--hsds-token-color-text-light);
  --hsds-token-dropList-color-togglers-navLink-text: var(--hsds-token-color-cobalt-300);
  --hsds-token-dropList-color-togglers-navLink-background: var(--hsds-token-color-cobalt-800);
  --hsds-token-dropList-color-togglers-navLink-attention: var(--hsds-token-color-magenta-accent);
  --hsds-token-dropList-color-togglers-splitButton-shadowDisabled: var(--hsds-token-color-charcoal-600);
  --hsds-token-dropList-color-togglers-splitButton-yellow-text-default: var(--hsds-token-color-orange-700);
  --hsds-token-dropList-color-togglers-splitButton-yellow-text-hover: var(--hsds-token-color-orange-800);
  --hsds-token-dropList-color-togglers-splitButton-yellow-bg-default: var(--hsds-token-color-yellow-100);
  --hsds-token-dropList-color-togglers-splitButton-yellow-bg-hover: var(--hsds-token-color-yellow-200);
  --hsds-token-dropList-color-togglers-splitButton-yellow-border-default: var(--hsds-token-color-yellow-400);
  --hsds-token-dropList-color-togglers-splitButton-yellow-border-hover: var(--hsds-token-color-yellow-500);
  --hsds-token-dropList-color-togglers-splitButton-yellow-disabled-bg: var(--hsds-token-color-charcoal-100);
  --hsds-token-dropList-color-togglers-splitButton-yellow-disabled-text: var(--hsds-token-color-charcoal-500);
  --hsds-token-dropList-color-togglers-select-shadow: var(--hsds-token-color-charcoal-500);
  --hsds-token-dropList-color-togglers-select-text: var(--hsds-token-color-charcoal-800);
  --hsds-token-dropList-color-togglers-select-shadowError: var(--hsds-token-color-state-error-borderColor);
  --hsds-token-dropList-color-togglers-select-disabled: var(--hsds-token-color-charcoal-600);
  --hsds-token-dropList-color-togglers-selectArrow-border: var(--hsds-token-color-charcoal-900);
  --hsds-token-dropList-radius-menu: 12px;
  --hsds-token-dropList-shadow-menu: var(--hsds-token-shadow-400);
  --hsds-token-editableField-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-editableField-color-mask-border: var(--hsds-token-color-charcoal-500);
  --hsds-token-editableField-color-mask-disabled: var(--hsds-token-color-charcoal-600);
  --hsds-token-editableField-color-mask-focused: rgba(197, 208, 217, 0.5);
  --hsds-token-editableField-color-mask-regular: var(--hsds-token-color-text-dark);
  --hsds-token-editableField-color-mask-placeholder-regular: var(--hsds-token-color-text-disabled);
  --hsds-token-editableField-color-mask-placeholder-disabled: var(--hsds-token-color-charcoal-600);
  --hsds-token-editableField-color-mask-placeholder-border-regular: var(--hsds-token-color-charcoal-500);
  --hsds-token-editableField-color-mask-placeholder-border-hover: var(--hsds-token-color-cobalt-600);
  --hsds-token-editableField-color-input-regular: var(--hsds-token-color-text-dark);
  --hsds-token-editableField-color-input-placeholder: var(--hsds-token-color-text-disabled);
  --hsds-token-editableField-color-label: var(--hsds-token-color-charcoal-500);
  --hsds-token-editableField-color-floatingLabel: var(--hsds-token-color-charcoal-500);
  --hsds-token-editableField-color-focusIndicator-active: var(--hsds-token-color-cobalt-600);
  --hsds-token-editableField-color-focusIndicator-inactive: #c6d0d8;
  --hsds-token-editableField-color-focusIndicator-default: var(--hsds-token-color-state-info-borderColor);
  --hsds-token-editableField-color-focusIndicator-error: var(--hsds-token-color-state-error-borderColor);
  --hsds-token-editableField-color-focusIndicator-warning: var(--hsds-token-color-state-warning-borderColor);
  --hsds-token-editableField-color-invisible: transparent;
  --hsds-token-editableField-color-closeButton-regular: var(--hsds-token-color-charcoal-600);
  --hsds-token-editableField-color-closeButton-hover: var(--hsds-token-color-text-dark);
  --hsds-token-editableField-color-closeButton-delete: var(--hsds-token-color-state-error-icon);
  --hsds-token-editableField-color-addButton-bg-default: var(--hsds-token-color-charcoal-200);
  --hsds-token-editableField-color-addButton-bg-hover: var(--hsds-token-color-cobalt-600);
  --hsds-token-editableField-color-addButton-bg-focus: var(--hsds-token-color-cobalt-600);
  --hsds-token-editableField-color-addButton-bg-disabled: var(--hsds-token-color-charcoal-200);
  --hsds-token-editableField-color-addButton-color-default: var(--hsds-token-color-charcoal-600);
  --hsds-token-editableField-color-addButton-color-hover: #fff;
  --hsds-token-editableField-color-addButton-color-focus: #fff;
  --hsds-token-editableField-color-addButton-color-disabled: #c6d0d8;
  --hsds-token-editableField-color-options-icon-hover: var(--hsds-token-color-charcoal-600);
  --hsds-token-editableField-color-options-icon-active: var(--hsds-token-color-text-dark);
  --hsds-token-emojiPicker-color-icon-default: var(--hsds-token-color-charcoal-500);
  --hsds-token-emojiPicker-color-icon-hover: var(--hsds-token-color-yellow-500);
  --hsds-token-filteredList-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-filteredList-color-item-text: var(--hsds-token-color-text-default);
  --hsds-token-filteredList-color-badge-text: var(--hsds-token-color-text-dark);
  --hsds-token-filteredList-color-badge-border: var(--hsds-token-color-charcoal-500);
  --hsds-token-filteredList-color-separator: var(--hsds-token-color-charcoal-500);
  --hsds-token-floatingToolbar-color-divider-charcoal: var(--hsds-token-color-charcoal-900);
  --hsds-token-floatingToolbar-color-divider-clay: var(--hsds-token-color-clay-400);
  --hsds-token-floatingToolbar-color-divider-white: var(--hsds-token-color-charcoal-300);
  --hsds-token-formField-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-formField-color-label-text: var(--hsds-token-color-text-default);
  --hsds-token-formField-color-itemMain-text: var(--hsds-token-color-text-dark);
  --hsds-token-formField-color-itemSecondary-text: var(--hsds-token-color-text-light);
  --hsds-token-heading-color-text: var(--hsds-token-color-text-headline);
  --hsds-token-heading-color-light: var(--hsds-token-color-charcoal-600);
  --hsds-token-heading-color-small-text: var(--hsds-token-color-text-default);
  --hsds-token-helpText-color-default: var(--hsds-token-color-text-subtle);
  --hsds-token-input-color-background-default: var(--hsds-token-color-background-surface);
  --hsds-token-input-color-background-disabled: var(--hsds-token-color-charcoal-100);
  --hsds-token-input-color-text: var(--hsds-token-color-text-default);
  --hsds-token-input-color-addOn-text: var(--hsds-token-color-text-dark);
  --hsds-token-input-color-placeholder-default: var(--hsds-token-color-text-disabled);
  --hsds-token-input-color-placeholder-error: var(--hsds-token-color-red-400);
  --hsds-token-input-color-placeholder-success: var(--hsds-token-color-green-500);
  --hsds-token-input-color-placeholder-warning: var(--hsds-token-color-orange-300);
  --hsds-token-input-color-control-default-color: var(--hsds-token-color-text-disabled);
  --hsds-token-input-color-control-default-bg: var(--hsds-token-color-charcoal-100);
  --hsds-token-input-color-control-default-border: var(--hsds-token-color-charcoal-500);
  --hsds-token-input-color-control-error-color: var(--hsds-token-color-red-500);
  --hsds-token-input-color-control-error-bg: var(--hsds-token-color-red-100);
  --hsds-token-input-color-control-error-border: var(--hsds-token-color-red-400);
  --hsds-token-input-color-control-success-color: var(--hsds-token-color-green-600);
  --hsds-token-input-color-control-success-bg: var(--hsds-token-color-green-100);
  --hsds-token-input-color-control-success-border: var(--hsds-token-color-green-500);
  --hsds-token-input-color-control-warning-color: var(--hsds-token-color-yellow-600);
  --hsds-token-input-color-control-warning-bg: var(--hsds-token-color-yellow-100);
  --hsds-token-input-color-control-warning-border: var(--hsds-token-color-orange-300);
  --hsds-token-input-radius-default: var(--hsds-token-radius-global);
  --hsds-token-inputCopy-color-confirm-color: var(--hsds-token-color-cobalt-600);
  --hsds-token-inputCopy-color-confirm-border: var(--hsds-token-color-cobalt-600);
  --hsds-token-inputCopy-color-background-default: var(--hsds-token-color-background-surface);
  --hsds-token-inputCopy-color-background-hover: var(--hsds-token-color-charcoal-200);
  --hsds-token-label-color-required: var(--hsds-token-color-red-500);
  --hsds-token-link-color-default: var(--hsds-token-color-cobalt-600);
  --hsds-token-link-color-hover: var(--hsds-token-color-cobalt-700);
  --hsds-token-link-color-active: var(--hsds-token-color-cobalt-800);
  --hsds-token-loadingDots-color-icon: var(--hsds-token-color-charcoal-500);
  --hsds-token-message-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-message-color-action-text: var(--hsds-token-color-charcoal-1000);
  --hsds-token-message-color-action-link-base: var(--hsds-token-color-link-base);
  --hsds-token-message-color-action-link-hover: var(--hsds-token-color-link-hover);
  --hsds-token-message-color-action-link-active: var(--hsds-token-color-link-active);
  --hsds-token-message-color-bubble-background-from: var(--hsds-token-color-charcoal-200);
  --hsds-token-message-color-bubble-background-to: var(--hsds-token-color-cobalt-200);
  --hsds-token-message-color-bubble-background-note: var(--hsds-token-color-yellow-200);
  --hsds-token-message-color-bubble-background-embed: var(--hsds-token-color-charcoal-300);
  --hsds-token-message-color-bubble-border-embed: var(--hsds-token-color-charcoal-300);
  --hsds-token-message-color-bubble-border-embedFrom: var(--hsds-token-color-charcoal-400);
  --hsds-token-message-color-bubble-border-note: var(--hsds-token-color-yellow-400);
  --hsds-token-message-color-bubble-text-default: var(--hsds-token-color-charcoal-1000);
  --hsds-token-message-color-bubble-text-note: var(--hsds-token-color-yellow-900);
  --hsds-token-message-color-bubble-embedBodyText: var(--hsds-token-color-text-default);
  --hsds-token-message-color-bubble-embedFromText: var(--hsds-token-color-text-default);
  --hsds-token-message-color-embed-text: var(--hsds-token-color-text-disabled);
  --hsds-token-message-color-embed-shadow: var(--hsds-token-color-charcoal-500);
  --hsds-token-message-color-embed-note-shadow: var(--hsds-token-color-yellow-400);
  --hsds-token-message-color-embed-note-background: var(--hsds-token-color-yellow-200);
  --hsds-token-message-color-embed-note-text: var(--hsds-token-color-yellow-800);
  --hsds-token-message-color-media-text: var(--hsds-token-color-text-disabled);
  --hsds-token-message-color-media-shadow: var(--hsds-token-color-charcoal-500);
  --hsds-token-message-color-media-note-shadow: var(--hsds-token-color-yellow-400);
  --hsds-token-message-color-media-note-background: var(--hsds-token-color-yellow-200);
  --hsds-token-message-color-media-note-text: var(--hsds-token-color-yellow-800);
  --hsds-token-message-color-media-error-shadow: var(--hsds-token-color-red-400);
  --hsds-token-message-color-media-error-text: var(--hsds-token-color-red-500);
  --hsds-token-messageCard-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-messageCard-color-outline: var(--hsds-token-color-cobalt-600);
  --hsds-token-messageCard-color-subtitle: var(--hsds-token-color-text-light);
  --hsds-token-messageCard-color-body: var(--hsds-token-color-charcoal-1000);
  --hsds-token-messageCard-color-blockquote-text: var(--hsds-token-color-text-light);
  --hsds-token-messageCard-color-blockquote-border: var(--hsds-token-color-charcoal-400);
  --hsds-token-messageCard-color-inlineCode-text: var(--hsds-token-color-red-500);
  --hsds-token-messageCard-color-inlineCode-background: var(--hsds-token-color-charcoal-200);
  --hsds-token-messageCard-color-pre-text: var(--hsds-token-color-charcoal-1100);
  --hsds-token-messageCard-color-pre-border: var(--hsds-token-color-charcoal-400);
  --hsds-token-messageCard-color-pre-background: var(--hsds-token-color-charcoal-100);
  --hsds-token-messageCard-color-link-base: var(--hsds-token-color-link-base);
  --hsds-token-messageCard-color-link-hover: var(--hsds-token-color-link-hover);
  --hsds-token-messageCard-color-link-active: var(--hsds-token-color-link-active);
  --hsds-token-messageCard-color-actionButton: var(--hsds-token-color-charcoal-500);
  --hsds-token-messageCard-color-strong: var(--hsds-token-color-charcoal-1100);
  --hsds-token-messageCard-color-articleCard-title: var(--hsds-token-color-text-dark);
  --hsds-token-messageCard-color-articleCard-meta: var(--hsds-token-color-text-light);
  --hsds-token-messageCard-color-articleCard-content: var(--hsds-token-color-text-light);
  --hsds-token-messageCard-color-surveyNps: var(--hsds-token-color-text-light);
  --hsds-token-messageCard-color-survey-feedback: var(--hsds-token-color-text-default);
  --hsds-token-messageCard-color-survey-spinner: var(--hsds-token-color-text-default);
  --hsds-token-messageCard-color-survey-confirmation: var(--hsds-token-color-text-default);
  --hsds-token-messageCard-color-survey-multiple: var(--hsds-token-color-charcoal-1000);
  --hsds-token-messageCard-color-modal-title: var(--hsds-token-color-charcoal-1000);
  --hsds-token-messageCard-color-modal-label: var(--hsds-token-color-text-light);
  --hsds-token-messageCard-color-modal-body: var(--hsds-token-color-charcoal-1000);
  --hsds-token-messageCard-color-modal-closeButton: var(--hsds-token-color-text-disabled);
  --hsds-token-messageCard-color-modal-closeButtonHover: var(--hsds-token-color-text-dark);
  --hsds-token-messageCard-color-nps-poweredby: var(--hsds-token-color-text-light);
  --hsds-token-messageCard-color-nps-question: var(--hsds-token-color-charcoal-1000);
  --hsds-token-messageCard-color-nps-feedback: var(--hsds-token-color-charcoal-1000);
  --hsds-token-modal-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-modal-color-header-title: var(--hsds-token-color-text-default);
  --hsds-token-modal-color-header-description: var(--hsds-token-color-text-disabled);
  --hsds-token-modal-color-dangerIcon: var(--hsds-token-color-red-500);
  --hsds-token-nav-color-text: var(--hsds-token-color-text-default);
  --hsds-token-optionCard-color-border-default: var(--hsds-token-color-charcoal-400);
  --hsds-token-optionCard-color-border-hover: var(--hsds-token-color-charcoal-500);
  --hsds-token-optionCard-color-border-checked: var(--hsds-token-color-cobalt-300);
  --hsds-token-optionCard-color-border-locked: var(--hsds-token-color-purple-300);
  --hsds-token-optionCard-color-bg-default: var(--hsds-token-color-background-surface);
  --hsds-token-optionCard-color-bg-hover: var(--hsds-token-color-charcoal-100);
  --hsds-token-optionCard-color-bg-checked: var(--hsds-token-color-cobalt-100);
  --hsds-token-optionCard-color-bg-locked: var(--hsds-token-color-purple-100);
  --hsds-token-optionCard-color-bg-disabled: var(--hsds-token-color-charcoal-100);
  --hsds-token-optionCard-color-mark-default: var(--hsds-token-color-cobalt-600);
  --hsds-token-optionCard-color-mark-locked-default: var(--hsds-token-color-purple-500);
  --hsds-token-optionCard-color-mark-locked-disabled: var(--hsds-token-color-purple-300);
  --hsds-token-optionCard-color-text-default: var(--hsds-token-color-text-light);
  --hsds-token-optionCard-color-text-checked: var(--hsds-token-color-text-default);
  --hsds-token-optionCard-color-text-disabled: var(--hsds-token-color-text-disabled);
  --hsds-token-optionCard-color-heading-default: var(--hsds-token-color-text-dark);
  --hsds-token-overflow-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-overlay-color-background: var(--hsds-token-color-charcoal-800);
  --hsds-token-overlay-alpha: 0.72;
  --hsds-token-page-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-page-color-header-title: var(--hsds-token-color-text-headline);
  --hsds-token-page-color-header-subtitle: var(--hsds-token-color-text-dark);
  --hsds-token-page-color-border: var(--hsds-token-color-charcoal-300);
  --hsds-token-pagination-color-information: var(--hsds-token-color-text-disabled);
  --hsds-token-pagination-color-range: var(--hsds-token-color-text-dark);
  --hsds-token-pagination-color-button-default: var(--hsds-token-color-charcoal-600);
  --hsds-token-pagination-color-button-hover: var(--hsds-token-color-charcoal-1000);
  --hsds-token-pagination-color-button-background: transparent;
  --hsds-token-pagination-color-button-borderColor: transparent;
  --hsds-token-pagination-color-button-hoverBackground: var(--hsds-token-color-charcoal-200);
  --hsds-token-pagination-color-button-hoverBorderColor: var(--hsds-token-color-charcoal-200);
  --hsds-token-pagination-color-button-disabledBackground: transparent;
  --hsds-token-pagination-color-button-disabledBorderColor: transparent;
  --hsds-token-popover-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-popover-color-border: var(--hsds-token-color-charcoal-500);
  --hsds-token-popover-color-heading: var(--hsds-token-color-text-light);
  --hsds-token-popover-color-text: var(--hsds-token-color-text-dark);
  --hsds-token-progressBar-color-background: var(--hsds-token-color-charcoal-100);
  --hsds-token-progressBar-color-progressFrom: #b9edbd;
  --hsds-token-progressBar-color-progressTo: #47c47d;
  --hsds-token-promo-color-default-background: var(--hsds-token-color-charcoal-100);
  --hsds-token-promo-color-default-boxShadow: var(--hsds-token-color-charcoal-100);
  --hsds-token-promo-color-default-border: var(--hsds-token-color-charcoal-300);
  --hsds-token-promo-color-default-text: var(--hsds-token-color-text-dark);
  --hsds-token-promo-color-default-icon: var(--hsds-token-color-text-dark);
  --hsds-token-promo-color-default-strong: var(--hsds-token-color-text-default);
  --hsds-token-promo-color-default-heading: var(--hsds-token-color-text-dark);
  --hsds-token-promo-color-info-background: var(--hsds-token-color-state-info-backgroundLight);
  --hsds-token-promo-color-info-boxShadow: var(--hsds-token-color-state-info-borderColor);
  --hsds-token-promo-color-info-border: var(--hsds-token-color-cobalt-300);
  --hsds-token-promo-color-info-text: var(--hsds-token-color-text-dark);
  --hsds-token-promo-color-info-icon: var(--hsds-token-color-state-info-icon);
  --hsds-token-promo-color-info-strong: var(--hsds-token-color-text-default);
  --hsds-token-promo-color-info-heading: var(--hsds-token-color-text-dark);
  --hsds-token-promo-color-warning-background: var(--hsds-token-color-state-warning-backgroundLight);
  --hsds-token-promo-color-warning-boxShadow: var(--hsds-token-color-state-warning-borderColor);
  --hsds-token-promo-color-warning-border: var(--hsds-token-color-yellow-300);
  --hsds-token-promo-color-warning-text: var(--hsds-token-color-orange-600);
  --hsds-token-promo-color-warning-icon: var(--hsds-token-color-state-warning-icon);
  --hsds-token-promo-color-warning-strong: var(--hsds-token-color-yellow-800);
  --hsds-token-promo-color-warning-heading: var(--hsds-token-color-yellow-800);
  --hsds-token-property-color-border-default: var(--hsds-token-color-border-ui);
  --hsds-token-property-color-border-hover: var(--hsds-token-color-charcoal-600);
  --hsds-token-property-color-label: var(--hsds-token-color-text-light);
  --hsds-token-property-color-text: var(--hsds-token-color-text-dark);
  --hsds-token-property-color-icon: var(--hsds-token-color-charcoal-900);
  --hsds-token-property-color-background-empty: var(--hsds-token-color-background-surface);
  --hsds-token-property-color-background-filled: var(--hsds-token-color-charcoal-100);
  --hsds-token-property-color-background-hoverValue: var(--hsds-token-color-charcoal-200);
  --hsds-token-property-color-background-hoverFilled: var(--hsds-token-color-cobalt-100);
  --hsds-token-property-color-background-editing: var(--hsds-token-color-cobalt-100);
  --hsds-token-property-color-input-placeholder: var(--hsds-token-color-text-disabled);
  --hsds-token-property-color-input-text: var(--hsds-token-color-text-dark);
  --hsds-token-property-color-error-border: var(--hsds-token-color-state-error-icon);
  --hsds-token-property-color-error-label: var(--hsds-token-color-state-error-text);
  --hsds-token-property-color-error-icon: var(--hsds-token-color-state-error-icon);
  --hsds-token-rateAction-color-outline: var(--hsds-token-color-green-500);
  --hsds-token-rateAction-color-boxShadow: var(--hsds-token-color-charcoal-500);
  --hsds-token-rateAction-color-circle-default: var(--hsds-token-color-charcoal-100);
  --hsds-token-rateAction-color-circle-happy: var(--hsds-token-color-yellow-200);
  --hsds-token-rateAction-color-circle-sad: var(--hsds-token-color-cobalt-100);
  --hsds-token-rateAction-color-circle-okay: var(--hsds-token-color-charcoal-200);
  --hsds-token-scrollable-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-sidePanel-color-background-overlay: var(--hsds-token-color-charcoal-1100);
  --hsds-token-sidePanel-color-background-surface: var(--hsds-token-color-background-surface);
  --hsds-token-sidePanel-color-background-body: var(--hsds-token-color-charcoal-200);
  --hsds-token-sidePanel-color-heading-text: var(--hsds-token-color-charcoal-1000);
  --hsds-token-sidePanel-color-heading-textHover: var(--hsds-token-color-charcoal-1100);
  --hsds-token-sidePanel-color-heading-icon: var(--hsds-token-color-charcoal-900);
  --hsds-token-sidePanel-color-heading-iconHover: var(--hsds-token-color-charcoal-1100);
  --hsds-token-sidePanel-color-border: var(--hsds-token-color-charcoal-400);
  --hsds-token-sidePanel-color-subheading: var(--hsds-token-color-text-light);
  --hsds-token-sidePanel-color-close: var(--hsds-token-color-charcoal-900);
  --hsds-token-sidePanel-color-closeHover: var(--hsds-token-color-charcoal-1000);
  --hsds-token-simpleModal-color-background-body: var(--hsds-token-color-background-surface);
  --hsds-token-simpleModal-color-background-overlay: var(--hsds-token-color-charcoal-800);
  --hsds-token-simpleModal-color-background-footer: var(--hsds-token-color-charcoal-100);
  --hsds-token-simpleModal-color-heading: var(--hsds-token-color-text-headline);
  --hsds-token-simpleModal-color-confirmationBody: var(--hsds-token-color-text-dark);
  --hsds-token-simpleModal-color-focus-outer: var(--hsds-token-color-cobalt-accent);
  --hsds-token-simpleModal-color-focus-inner: var(--hsds-token-color-charcoal-600);
  --hsds-token-skeleton-color-background: var(--hsds-token-color-charcoal-200);
  --hsds-token-skeleton-color-backgroundShine: var(--hsds-token-color-charcoal-100);
  --hsds-token-sortable-color-dragHandler-default-color: var(--hsds-token-color-charcoal-900);
  --hsds-token-sortable-color-dragHandler-default-bg: transparent;
  --hsds-token-sortable-color-dragHandler-active-color: var(--hsds-token-color-charcoal-700);
  --hsds-token-sortable-color-dragHandler-active-bg: var(--hsds-token-color-charcoal-200);
  --hsds-token-sortable-color-dragHandler-disabled: var(--hsds-token-color-charcoal-500);
  --hsds-token-squircle-color-variant-charcoal-background: var(--hsds-token-color-charcoal-200);
  --hsds-token-squircle-color-variant-charcoal-text: var(--hsds-token-color-charcoal-600);
  --hsds-token-squircle-color-variant-blue-background: var(--hsds-token-color-cobalt-200);
  --hsds-token-squircle-color-variant-blue-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-squircle-color-variant-green-background: var(--hsds-token-color-green-200);
  --hsds-token-squircle-color-variant-green-text: var(--hsds-token-color-green-600);
  --hsds-token-squircle-color-variant-purple-background: var(--hsds-token-color-purple-200);
  --hsds-token-squircle-color-variant-purple-text: var(--hsds-token-color-purple-600);
  --hsds-token-squircle-color-variant-yellow-background: var(--hsds-token-color-yellow-200);
  --hsds-token-squircle-color-variant-yellow-text: var(--hsds-token-color-yellow-600);
  --hsds-token-squircle-color-variant-red-background: var(--hsds-token-color-red-200);
  --hsds-token-squircle-color-variant-red-text: var(--hsds-token-color-red-600);
  --hsds-token-squircle-color-variant-cobalt-background: var(--hsds-token-color-cobalt-200);
  --hsds-token-squircle-color-variant-cobalt-text: var(--hsds-token-color-cobalt-600);
  --hsds-token-squircle-color-variant-info-background: var(--hsds-token-color-state-info-icon);
  --hsds-token-squircle-color-variant-info-text: white;
  --hsds-token-squircle-color-variant-clay-background: var(--hsds-token-color-clay-200);
  --hsds-token-squircle-color-variant-clay-text: var(--hsds-token-color-clay-600);
  --hsds-token-squircle-color-variant-orange-background: var(--hsds-token-color-orange-200);
  --hsds-token-squircle-color-variant-orange-text: var(--hsds-token-color-orange-600);
  --hsds-token-squircle-color-variant-white-background: white;
  --hsds-token-squircle-color-variant-white-text: var(--hsds-token-color-charcoal-900);
  --hsds-token-squircle-color-variant-magenta-background: var(--hsds-token-color-magenta-200);
  --hsds-token-squircle-color-variant-magenta-text: var(--hsds-token-color-magenta-600);
  --hsds-token-statusBar-color-light-error-border: var(--hsds-token-color-red-200);
  --hsds-token-statusBar-color-light-error-background: var(--hsds-token-color-state-error-backgroundLight);
  --hsds-token-statusBar-color-light-error-text: var(--hsds-token-color-state-error-text);
  --hsds-token-statusBar-color-light-info-border: var(--hsds-token-color-cobalt-200);
  --hsds-token-statusBar-color-light-info-background: var(--hsds-token-color-state-info-backgroundLight);
  --hsds-token-statusBar-color-light-info-text: var(--hsds-token-color-state-info-text);
  --hsds-token-statusBar-color-light-success-border: var(--hsds-token-color-green-200);
  --hsds-token-statusBar-color-light-success-background: var(--hsds-token-color-state-success-backgroundLight);
  --hsds-token-statusBar-color-light-success-text: var(--hsds-token-color-state-success-text);
  --hsds-token-statusBar-color-light-warning-border: var(--hsds-token-color-yellow-200);
  --hsds-token-statusBar-color-light-warning-background: var(--hsds-token-color-state-warning-backgroundLight);
  --hsds-token-statusBar-color-light-warning-text: var(--hsds-token-color-state-warning-text);
  --hsds-token-statusBar-color-bold-error-border: var(--hsds-token-color-red-700);
  --hsds-token-statusBar-color-bold-error-button: var(--hsds-token-color-red-700);
  --hsds-token-statusBar-color-bold-error-background: var(--hsds-token-color-state-error-backgroundDark);
  --hsds-token-statusBar-color-bold-error-text: white;
  --hsds-token-statusBar-color-bold-info-border: var(--hsds-token-color-cobalt-700);
  --hsds-token-statusBar-color-bold-info-button: var(--hsds-token-color-cobalt-700);
  --hsds-token-statusBar-color-bold-info-background: var(--hsds-token-color-state-info-backgroundDark);
  --hsds-token-statusBar-color-bold-info-text: white;
  --hsds-token-statusBar-color-bold-success-border: var(--hsds-token-color-green-700);
  --hsds-token-statusBar-color-bold-success-button: var(--hsds-token-color-green-700);
  --hsds-token-statusBar-color-bold-success-background: var(--hsds-token-color-state-success-backgroundDark);
  --hsds-token-statusBar-color-bold-success-text: white;
  --hsds-token-statusBar-color-bold-warning-border: var(--hsds-token-color-orange-700);
  --hsds-token-statusBar-color-bold-warning-button: var(--hsds-token-color-orange-700);
  --hsds-token-statusBar-color-bold-warning-background: var(--hsds-token-color-state-warning-backgroundDark);
  --hsds-token-statusBar-color-bold-warning-text: white;
  --hsds-token-statusDot-color-light-background: white;
  --hsds-token-statusDot-color-light-green: var(--hsds-token-color-green-500);
  --hsds-token-statusDot-color-light-slate: var(--hsds-token-color-slate-500);
  --hsds-token-statusDot-color-light-red: var(--hsds-token-color-red-500);
  --hsds-token-statusDot-color-light-yellow: var(--hsds-token-color-yellow-400);
  --hsds-token-statusDot-color-light-purple: var(--hsds-token-color-purple-400);
  --hsds-token-statusDot-color-light-charcoal: var(--hsds-token-color-charcoal-500);
  --hsds-token-statusDot-color-dark-background: var(--hsds-token-color-cobalt-700);
  --hsds-token-statusDot-color-dark-green: var(--hsds-token-color-green-accent);
  --hsds-token-statusDot-color-dark-slate: var(--hsds-token-color-slate-accent);
  --hsds-token-statusDot-color-dark-red: var(--hsds-token-color-red-accent);
  --hsds-token-statusDot-color-dark-yellow: var(--hsds-token-color-yellow-accent);
  --hsds-token-statusDot-color-dark-purple: var(--hsds-token-color-purple-accent);
  --hsds-token-statusDot-color-dark-charcoal: var(--hsds-token-color-charcoal-500);
  --hsds-token-stepper-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-switchComponent-color-toggle-bg: #fff;
  --hsds-token-switchComponent-color-toggle-boxShadow: rgba(0, 0, 0, 0.1);
  --hsds-token-switchComponent-color-backdrop-bg-default: var(--hsds-token-color-charcoal-400);
  --hsds-token-switchComponent-color-backdrop-bg-hover: var(--hsds-token-color-charcoal-500);
  --hsds-token-switchComponent-color-backdrop-bg-hoverChecked: var(--hsds-token-color-green-600);
  --hsds-token-switchComponent-color-backdrop-bg-disabled: var(--hsds-token-color-charcoal-200);
  --hsds-token-switchComponent-color-backdrop-bg-checked: var(--hsds-token-color-green-500);
  --hsds-token-switchComponent-color-backdrop-color-default: var(--hsds-token-color-charcoal-600);
  --hsds-token-switchComponent-color-backdrop-color-disabled: var(--hsds-token-color-charcoal-700);
  --hsds-token-switchComponent-color-backdrop-color-checked: #fff;
  --hsds-token-switchComponent-color-backdrop-color-checkedDisabled: var(--hsds-token-color-charcoal-700);
  --hsds-token-switchComponent-color-state-error-boxShadow1: #fff;
  --hsds-token-switchComponent-color-state-error-boxShadow2: var(--hsds-token-color-state-error-borderColor);
  --hsds-token-switchComponent-color-state-error-boxShadow3: var(--hsds-token-color-red-200);
  --hsds-token-tabBar-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-tabBar-color-border: var(--hsds-token-color-charcoal-400);
  --hsds-token-tabBar-color-selected: var(--hsds-token-color-cobalt-600);
  --hsds-token-tabBar-color-text-default: var(--hsds-token-color-text-light);
  --hsds-token-tabBar-color-text-disabled: var(--hsds-token-color-text-disabled);
  --hsds-token-tabBar-color-text-active: var(--hsds-token-color-text-dark);
  --hsds-token-table-color-background-default: var(--hsds-token-color-background-surface);
  --hsds-token-table-color-background-cell: var(--hsds-token-color-charcoal-100);
  --hsds-token-table-color-background-hover: var(--hsds-token-color-charcoal-100);
  --hsds-token-table-color-background-focus: var(--hsds-token-color-cobalt-100);
  --hsds-token-table-color-background-focusIndicator: var(--hsds-token-color-cobalt-600);
  --hsds-token-table-color-background-selectedHover: var(--hsds-token-color-cobalt-200);
  --hsds-token-table-color-background-alternativeHeader: var(--hsds-token-color-charcoal-300);
  --hsds-token-table-color-border: var(--hsds-token-color-charcoal-300);
  --hsds-token-table-color-text: var(--hsds-token-color-text-dark);
  --hsds-token-table-color-typeAction: var(--hsds-token-color-text-disabled);
  --hsds-token-table-color-sortableCell-text-default: var(--hsds-token-color-charcoal-600);
  --hsds-token-table-color-sortableCell-text-sorted: var(--hsds-token-color-charcoal-900);
  --hsds-token-table-color-sortableCell-bg: var(--hsds-token-color-charcoal-200);
  --hsds-token-tag-palette-light-blue: var(--hsds-token-color-pastel-light-blue);
  --hsds-token-tag-palette-light-green: var(--hsds-token-color-pastel-light-green);
  --hsds-token-tag-palette-light-grey: var(--hsds-token-color-charcoal-300);
  --hsds-token-tag-palette-light-purple: var(--hsds-token-color-pastel-light-purple);
  --hsds-token-tag-palette-light-red: var(--hsds-token-color-pastel-light-red);
  --hsds-token-tag-palette-light-yellow: var(--hsds-token-color-pastel-light-yellow);
  --hsds-token-tag-palette-light-teal: var(--hsds-token-color-pastel-light-teal);
  --hsds-token-tag-palette-light-pink: var(--hsds-token-color-pastel-light-pink);
  --hsds-token-tag-palette-light-orange: var(--hsds-token-color-pastel-light-orange);
  --hsds-token-tag-palette-dark-blue: var(--hsds-token-color-pastel-dark-blue);
  --hsds-token-tag-palette-dark-green: var(--hsds-token-color-pastel-dark-green);
  --hsds-token-tag-palette-dark-grey: var(--hsds-token-color-charcoal-600);
  --hsds-token-tag-palette-dark-purple: var(--hsds-token-color-pastel-dark-purple);
  --hsds-token-tag-palette-dark-red: var(--hsds-token-color-pastel-dark-red);
  --hsds-token-tag-palette-dark-yellow: var(--hsds-token-color-pastel-dark-yellow);
  --hsds-token-tag-palette-dark-teal: var(--hsds-token-color-pastel-dark-teal);
  --hsds-token-tag-palette-dark-pink: var(--hsds-token-color-pastel-dark-pink);
  --hsds-token-tag-palette-dark-orange: var(--hsds-token-color-pastel-dark-orange);
  --hsds-token-tag-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-tag-color-text: var(--hsds-token-color-text-dark);
  --hsds-token-tag-color-showAll-text: var(--hsds-token-color-text-dark);
  --hsds-token-tag-color-showAll-border: var(--hsds-token-color-charcoal-300);
  --hsds-token-tag-color-showAll-bg: var(--hsds-token-color-charcoal-300);
  --hsds-token-tag-color-clearAll: var(--hsds-token-color-text-disabled);
  --hsds-token-tag-color-clearAllHover: var(--hsds-token-color-text-light);
  --hsds-token-text-color-default: var(--hsds-token-color-text-default);
  --hsds-token-text-color-error: var(--hsds-token-color-state-error-color);
  --hsds-token-text-color-success: var(--hsds-token-color-state-success-color);
  --hsds-token-text-color-warning: var(--hsds-token-color-state-warning-color);
  --hsds-token-text-color-light: var(--hsds-token-color-text-light);
  --hsds-token-text-color-subtle: var(--hsds-token-color-text-subtle);
  --hsds-token-text-color-slightlyMuted: var(--hsds-token-color-text-slightlyMuted);
  --hsds-token-text-color-muted: var(--hsds-token-color-text-muted);
  --hsds-token-text-color-faint: var(--hsds-token-color-text-faint);
  --hsds-token-text-color-extraMuted: var(--hsds-token-color-text-extraMuted);
  --hsds-token-text-color-link: var(--hsds-token-color-link-base);
  --hsds-token-timeline-color-default: var(--hsds-token-color-text-dark);
  --hsds-token-timeline-color-dotBackground-default: var(--hsds-token-color-background-surface);
  --hsds-token-timeline-color-dotBackground-active: var(--hsds-token-color-cobalt-500);
  --hsds-token-timeline-color-border: var(--hsds-token-color-charcoal-400);
  --hsds-token-timeline-color-dotBorder-default: var(--hsds-token-color-charcoal-500);
  --hsds-token-timeline-color-dotBorder-active: var(--hsds-token-color-cobalt-500);
  --hsds-token-timeline-item-color-text: var(--hsds-token-color-text-dark);
  --hsds-token-timeline-item-color-dot-active: var(--hsds-token-color-slate-accent);
  --hsds-token-toolbar-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-toolbar-color-border: var(--hsds-token-color-border-default);
  --hsds-token-toolbar-color-note-text: var(--hsds-token-color-yellow-100);
  --hsds-token-toolbar-color-note-background: var(--hsds-token-color-yellow-800);
  --hsds-token-tooltip-color-bg: var(--hsds-token-color-charcoal-1100);
  --hsds-token-tooltip-color-title: var(--hsds-token-color-cobalt-accent);
  --hsds-token-tooltip-color-badge-bg: var(--hsds-token-color-charcoal-800);
  --hsds-token-tooltip-color-badge-text: var(--hsds-token-color-background-surface);
  --hsds-token-typingDots-color-dot1: var(--hsds-token-color-charcoal-500);
  --hsds-token-typingDots-color-dot2: var(--hsds-token-color-charcoal-400);
  --hsds-token-typingDots-color-dot3: var(--hsds-token-color-charcoal-200);
  --hsds-token-verificationCode-color-error: var(--hsds-token-color-state-error-default);
  --hsds-token-verificationCode-color-background: var(--hsds-token-color-background-surface);
  --hsds-token-verificationCode-color-border: var(--hsds-token-color-charcoal-500);
  --hsds-token-verificationCode-color-digit-text: var(--hsds-token-color-text-dark);
  --hsds-token-verificationCode-color-digit-mask-border: #d5dce1;
  --hsds-token-verificationCode-color-digit-border-default: var(--hsds-token-color-charcoal-400);
  --hsds-token-verificationCode-color-digit-border-focus: var(--hsds-token-color-cobalt-600);
  --hsds-token-verificationCode-color-digit-selection: #b2d7ff;
  --hsds-token-measure-focusRing-innerBoxShadowSize: 1px;
  --hsds-token-measure-focusRing-outerBoxShadowSize: 3px;
  --hsds-token-measure-focusRing-insetBoxShadowSize: 2px;
`;
export {
  o as tokens
};
